
import { isAssignToolsOnboardingTourToolDetailPhase, withoutOnboardingTourQueryParams, withoutProblemReportIdQueryParam, formatReminderInterval, priceToString } from "../../../Common.js";
import { now as now_1, utcNow, date as date_3, addDays, addYears, addMonths, compare, toLocalTime, toString } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { stringHash, equals, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { split, isNullOrWhiteSpace, concat, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { Button, TextDropdownButton, TextButton } from "../../../Components/Button.js";
import { choose, append as append_1, indexed, tail as tail_1, head as head_1, reduce, toArray, take, length, empty as empty_1, tryFind, singleton as singleton_1, isEmpty, sortByDescending, map, contains, exists, filter, sortBy, tryHead, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { map as map_2, collect, empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { useTranslation } from "react-i18next";
import { ToolDetailDto__ReadableDisplayName, Helper_historyTypeToTranslationString, ProblemReportState } from "../../../Shared/Tool.js";
import { AreaAnchorMenu, selectAndScroll } from "../../../Widgets/AnchorMenu.js";
import { toString as toString_2, Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, bool_type, int32_type, list_type, option_type, anonRecord_type, class_type, string_type, union_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { flatten, map as map_1, defaultArg, bind, unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import Calendar_Warning from "../../../../public/assets/icons/Calendar_Warning.svg";
import { DTO_UpdateInspectionResultDto, DTO_WriteInspectionResultDto, DTO_WriteInspectionResultDto_$reflection, InspectionResultStatus } from "../../../Shared/InspectionResult.js";
import { ColoredDot } from "../../../Components/ColoredDot.js";
import { ChangeStorageDialog } from "../Dialogs/SwitchStorageDialog.js";
import { toast } from "react-hot-toast";
import { FileEntry, FileEntry_$reflection, Msg } from "./Types.js";
import { ChangeReturnDateDialog } from "../../Dialogs/ChangeReturnDateDialog.js";
import { RequestTargetId as RequestTargetId_1, ChangeBusinessUnitDialog } from "../../../Widgets/ChangeBusinessUnitDialog.js";
import { ReleaseDateDialog } from "../../Dialogs/ReleaseDateDialog.js";
import { TextValue } from "../../../Components/Text.js";
import { RouterModule_encodeQueryString, RouterModule_encodeParts, RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Feature, isFeatureEnabled } from "../../../FeatureFlip.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { QuickOverviewList } from "../../../Widgets/QuickOverviewList.js";
import Following from "../../../../public/assets/icons/Following.svg";
import Followers from "../../../../public/assets/icons/Followers.svg";
import { EditReservation_EditToolReservationDialog, NewReservation_AddToolReservationDialog } from "../../Dialogs/ToolReservationDialog.js";
import { AssignToolDialog } from "../../Dialogs/AssignToolDialog.js";
import { UnassignDialog } from "../../Dialogs/UnassignToolDialog.js";
import { ReturnToolNotificationDialog } from "../../Dialogs/ReturnToolNotificationDialog.js";
import { SelfServiceAssignToolDialog } from "../../Dialogs/SelfServiceAssignToolDialog.js";
import { SelfServiceReturnToolDialog } from "../../Dialogs/SelfServiceReturnToolDialog.js";
import { ToolCreateProblemReportDialog } from "../../Dialogs/ToolCreateProblemReportDialog.js";
import { parse } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { InspectionResultId as InspectionResultId_1, FormState__startLoading, FormState_get_empty, FormState_$reflection, PostResponse$1_$reflection, EmptyResponse_$reflection, ClientApiResponse$1_$reflection, NoticeId, SetId__get_unwrap, DocumentId__get_unwrap, ToolId as ToolId_4 } from "../../../Shared/Shared.js";
import { StartProcedureDialog } from "../../Dialogs/StartProcedureDialog.js";
import { OpenDialog } from "../../Dialogs/AssignToolFromUserToUserDialog.js";
import { ToolStateChangeDialog } from "../../Dialogs/ToolStateChangeDialog.js";
import Calendar_Add from "../../../../public/assets/icons/Calendar_Add.svg";
import { unwrapToolId, unwrapStorageId } from "../../../Shared/Helper.js";
import Order_History from "../../../../public/assets/icons/Order_History.svg";
import Shipment_Warning from "../../../../public/assets/icons/Shipment_Warning.svg";
import Shipment_Check from "../../../../public/assets/icons/Shipment_Check.svg";
import Shipment_Delivery_Fail from "../../../../public/assets/icons/Shipment_Delivery_Fail.svg";
import Shipment_Search from "../../../../public/assets/icons/Shipment_Search.svg";
import Shipment_Time from "../../../../public/assets/icons/Shipment_Time.svg";
import { PropertyList } from "../../../Widgets/PropertyListWidget.js";
import { CustomPropertiesPropertyList } from "../../../Widgets/CustomPropertiesPropertyList.js";
import { QrCodeTable, AssetIdentifierTable } from "../../../Widgets/Table/QrCodeTable.js";
import { ModalSheet } from "../../../Components/ModalSheet.js";
import { DocumentTable } from "../../../Widgets/Table/DocumentTable.js";
import { OpenChangelogButtonModalSheet } from "../../../Widgets/Modals/ChangelogModal.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { UploadType as UploadType_2 } from "../../../Widgets/Dialogs/FileUploadDialog.js";
import { DeleteToolReservationDialog } from "../../Dialogs/ToolDeleteReservation.js";
import { TableControl$1, Table } from "../../../Widgets/Table/Table.js";
import Pencil from "../../../../public/assets/icons/Pencil.svg";
import Recycle_Bin_1 from "../../../../public/assets/icons/Recycle_Bin_1.svg";
import { OpenDialog as OpenDialog_1 } from "./InspectionFromReminderDialog.js";
import { ConfirmDialog_ConfirmReminderDialog, DeleteReminder_OpenDialog, EditReminder_OpenDialog, NewReminder_OpenDialog } from "../../Dialogs/AddReminderDialog.js";
import { FileDialog_LinkedDocumentToolType, FileDialog_LinkedEntityId, Modal_OpenLinkedDocumentModalButtonModalSheet } from "../../../Widgets/Modals/LinkedDocumentModal.js";
import Check from "../../../../public/assets/icons/Check.svg";
import Check_Circle from "../../../../public/assets/icons/Check_Circle.svg";
import { Helper_displayHistoryComment } from "../../../Shared/Changelog.js";
import { AssignmentProtocolDialog, AssignmentProtocolParams } from "../../../Widgets/AssignmentProtocol.js";
import { ProblemReportDialog } from "../../Dialogs/ProblemReportDialog.js";
import { Dialog, ConfirmationDialog } from "../../../Components/Dialog.js";
import Information_Circle from "../../../../public/assets/icons/Information_Circle.svg";
import { NotificationArea } from "../../../Widgets/Notification/NotificationArea.js";
import { NotificationToolType as NotificationToolType_1 } from "../../../Widgets/Notification/AcceptNotificationDialog.js";
import { MultipleImageWidget } from "../../../Widgets/Image/ImageWidget.js";
import { ChatWidget, Message as Message_1 } from "../../../Widgets/ChatWidget.js";
import { OpenNoticeDeleteDialog } from "../../Dialogs/ToolDeleteNoticeDialog.js";
import { DTO_InspectionTemplateDetailDto_$reflection } from "../../../Shared/InspectionTemplate.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch, Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString as toString_1 } from "../../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../../Communication.js";
import { Cmd_errorToast, Cmd_successToast } from "../../../Components/Toast.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { nativeType, useDrop } from "../../../Bindings/Fable.ReactDnD.js";
import { SelectWithColor, Select } from "../../../Components/Select.js";
import { DatePicker } from "../../../Components/DatePicker.js";
import { TextArea } from "../../../Components/TextArea.js";
import Upload_File from "../../../../public/assets/icons/Upload_File.svg";
import { rangeDouble } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Range.js";
import New_File from "../../../../public/assets/icons/New_File.svg";
import Delete_Circle from "../../../../public/assets/icons/Delete_Circle.svg";
import { Input } from "../../../Components/Input.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { InformationAlert } from "../../../Components/Alert.js";
import { isVisibleForUserByToolDetailDto } from "../../Common.js";
import { OpenToolDeleteDialog } from "../../Dialogs/ToolDeleteDialog.js";
import { DetailViewHeader } from "../../../Widgets/DetailViewHeader.js";
import { Badge } from "../../../Components/Badge.js";
import { TableContainerWithTabs, TableContainer, SectionContainer } from "../../../Widgets/Container.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { ChangelogTable } from "../../../Widgets/Table/ChangelogTable.js";
import { update as update_1, initViewTool } from "./State.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../../Components/TourGuide.js";

export function price(p, currency) {
    if (p == null) {
        return "";
    }
    else {
        return priceToString(p, currency);
    }
}

export function purchaseDate(d) {
    if (d == null) {
        return "";
    }
    else {
        return toString(toLocalTime(d), "dd.MM.yyyy");
    }
}

export function Box(props) {
    let elems_2, elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-background", "py-3", "px-4", "flex", "flex-col", "rounded"])], (elems_2 = [reactElement("div", {
        className: join(" ", ["text-sm", "font-semibold"]),
        children: props.Title,
    }), reactElement("div", {
        className: join(" ", ["flex", "flex-col", "divide-y", "divide-[#e9edf3]", "gap-2", "my-4", "grow"]),
        children: reactApi.Children.toArray([props.ContentElement]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = [createElement(TextButton, {
        ComponentState: "enabled",
        Label: props.AdditionalInformation,
        OnClick: props.OnClick,
        TestId: concat("tool-selectcard-", props.AdditionalInformation, ..."-edit-button"),
        Variant: "blueButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function InformationBox(props) {
    let elems_2;
    const contextLength = (props.ContentText.length > 100) ? concat(props.ContentText.slice(undefined, 100 + 1), ..."[...]") : props.ContentText;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "drop-shadow-lg", "p-4"])], (elems_2 = toList(delay(() => {
        let matchValue, iconElement, elems_1;
        return append((matchValue = props.Icon, (matchValue != null) ? ((iconElement = matchValue, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-between"])], (elems_1 = [reactElement("div", {
            className: join(" ", ["text-sm"]),
            children: contextLength,
        }), reactElement("div", {
            className: join(" ", ["text-red", "h-5", "w-5"]),
            children: reactApi.Children.toArray([iconElement]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))))) : singleton(reactElement("div", {
            className: join(" ", ["text-sm"]),
            children: contextLength,
        }))), delay(() => {
            const matchValue_1 = props.Title;
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                const title = matchValue_1;
                return singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "font-semibold", "mt-3"]),
                    children: title,
                }));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function NotificationsBox(props) {
    let Title_2;
    const t = useTranslation()[0];
    const problemReport = tryHead(sortBy((pr_1) => pr_1.Timestamp, filter((pr) => equals(pr.State, new ProblemReportState(0, [])), props.ProblemReports), {
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const content = (problemReport == null) ? createElement(InformationBox, {
        ContentText: t("general.no_content"),
    }) : createElement(InformationBox, {
        ContentText: problemReport.Message,
    });
    return Box((Title_2 = t("tool.current_problem_report"), {
        AdditionalInformation: t("tool.to_problem_reports"),
        ContentElement: content,
        OnClick: () => {
            selectAndScroll(props.SetCurrentSelectedLink, "problem-report-section-id");
        },
        Title: Title_2,
    }));
}

function calcNextInspectionDate(interval, customInterval, lastDate) {
    switch (interval.tag) {
        case 1:
            return addMonths(lastDate, 1);
        case 2:
            return addMonths(lastDate, 3);
        case 3:
            return addMonths(lastDate, 6);
        case 4:
            return addYears(lastDate, 1);
        case 5:
            return addYears(lastDate, 2);
        case 6:
            if (customInterval == null) {
                return undefined;
            }
            else {
                const ci = customInterval;
                const matchValue = ci.Interval;
                switch (matchValue) {
                    case "month":
                        return addMonths(lastDate, ci.Value);
                    case "week":
                        return addDays(lastDate, ci.Value * 7);
                    case "year":
                        return addYears(lastDate, ci.Value);
                    default:
                        return addDays(lastDate, ci.Value);
                }
            }
        default:
            return addDays(lastDate, 7);
    }
}

class InspectionStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Ok", "Upcoming", "Overdue", "NeverInspected"];
    }
}

function InspectionStatus_$reflection() {
    return union_type("Tools.Tool.Details.View.InspectionStatus", [], InspectionStatus, () => [[], [], [], []]);
}

export function PlanningBox(props) {
    let appointment_1, reservation_1, ContentText_3, Title_3, appointment, ContentText_1, Title_1, reservation, Title_5;
    const t = useTranslation()[0];
    const today = date_3(utcNow());
    const firstAppointment = tryHead(sortBy((a_1) => a_1.Date, filter((a) => !a.IsConfirmed, props.Tool.ReminderDates), {
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const nextReservation = tryHead(sortBy((r_1) => r_1.StartDate, filter((r) => (compare(r.StartDate, today) >= 0), props.Tool.Reservations), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }));
    const reminderLabel = t("tool.planning.reminder");
    const reservationLabel = t("tool.planning.reservation");
    const content = (firstAppointment != null) ? ((nextReservation != null) ? ((appointment_1 = firstAppointment, (reservation_1 = nextReservation, (compare(appointment_1.Date, reservation_1.StartDate) <= 0) ? createElement(InformationBox, (ContentText_3 = toString(appointment_1.Date, "dd.MM.yyyy"), (Title_3 = concat(reminderLabel, ": ", ...appointment_1.Title), {
        ContentText: ContentText_3,
        Icon: unwrap((compare(date_3(appointment_1.Date), today) <= 0) ? Calendar_Warning() : undefined),
        Title: unwrap(Title_3),
    }))) : createElement(InformationBox, {
        ContentText: concat(toString(reservation_1.StartDate, "dd.MM.yyyy"), " - ", ...toString(reservation_1.EndDate, "dd.MM.yyyy")),
        Title: concat(reservationLabel, ": ", ...reservation_1.ReceiverInformation.ReceiverName),
    })))) : ((appointment = firstAppointment, createElement(InformationBox, (ContentText_1 = toString(appointment.Date, "dd.MM.yyyy"), (Title_1 = concat(reminderLabel, ": ", ...appointment.Title), {
        ContentText: ContentText_1,
        Icon: unwrap((compare(date_3(appointment.Date), today) <= 0) ? Calendar_Warning() : undefined),
        Title: unwrap(Title_1),
    })))))) : ((nextReservation != null) ? ((reservation = nextReservation, createElement(InformationBox, {
        ContentText: concat(toString(reservation.StartDate, "dd.MM.yyyy"), " - ", ...toString(reservation.EndDate, "dd.MM.yyyy")),
        Title: concat(reservationLabel, ": ", ...reservation.ReceiverInformation.ReceiverName),
    }))) : createElement(InformationBox, {
        ContentText: t("general.no_content"),
    }));
    return Box((Title_5 = t("tool.planning.title"), {
        AdditionalInformation: t("general.to_planning"),
        ContentElement: content,
        OnClick: () => {
            selectAndScroll(props.SetCurrentSelectedLink, "appointments-section-id");
        },
        Title: Title_5,
    }));
}

export function InspectionStatusBox(props) {
    let Title_1;
    const t = useTranslation()[0];
    const now = date_3(utcNow());
    const relevantTemplates = filter((tmpl) => exists((catId) => contains(catId, props.ToolCategoryIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), tmpl.CategoryIds), props.InspectionTemplates);
    const templateDetails = map((tmpl_1) => {
        let r_6, nextDue_2, nextDue_3;
        const lastResult = tryHead(sortByDescending((r_1) => r_1.InspectionDate, filter((r) => (r.InspectionTemplateId === tmpl_1.Id), props.InspectionResults), {
            Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
        }));
        const nextDueDate = bind((r_4) => calcNextInspectionDate(tmpl_1.Interval, tmpl_1.CustomInterval, r_4.InspectionDate), tryHead(sortByDescending((r_3) => r_3.InspectionDate, filter((r_2) => {
            if (r_2.InspectionTemplateId === tmpl_1.Id) {
                return equals(r_2.ResultStatus, new InspectionResultStatus(0, []));
            }
            else {
                return false;
            }
        }, props.InspectionResults), {
            Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
        })));
        return [tmpl_1, (lastResult != null) ? (equals(lastResult.ResultStatus, new InspectionResultStatus(1, [])) ? ((r_6 = lastResult, new InspectionStatus(2, []))) : ((nextDueDate == null) ? (new InspectionStatus(3, [])) : ((compare(date_3(nextDueDate), now) < 0) ? ((nextDue_2 = nextDueDate, new InspectionStatus(2, []))) : ((compare(date_3(nextDueDate), addDays(now, 30)) <= 0) ? ((nextDue_3 = nextDueDate, new InspectionStatus(1, []))) : (new InspectionStatus(0, [])))))) : (new InspectionStatus(3, [])), lastResult, nextDueDate];
    }, relevantTemplates);
    let content;
    if (isEmpty(relevantTemplates)) {
        content = createElement(InformationBox, {
            ContentText: t("inspection_status.no_obligations"),
        });
    }
    else {
        const xs_5 = toList(delay(() => collect((matchValue_1) => {
            let elems_2, elems_1, elems;
            const status_1 = matchValue_1[1];
            const nextDueDate_1 = matchValue_1[3];
            const lastResult_1 = matchValue_1[2];
            const statusColor = (status_1.tag === 1) ? "orange" : ((status_1.tag === 2) ? "red" : ((status_1.tag === 3) ? "orange" : "green"));
            let dateText;
            switch (status_1.tag) {
                case 1: {
                    if (nextDueDate_1 == null) {
                        dateText = "";
                    }
                    else {
                        const d_1 = nextDueDate_1;
                        dateText = concat(t("inspection_status.next_due"), ": ", ...toString(toLocalTime(d_1), "dd.MM.yyyy"));
                    }
                    break;
                }
                case 2: {
                    let matchResult, r_8;
                    if (lastResult_1 != null) {
                        if (equals(lastResult_1.ResultStatus, new InspectionResultStatus(1, []))) {
                            matchResult = 0;
                            r_8 = lastResult_1;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0: {
                            dateText = concat(t("inspection_status.last_inspection"), ": ", ...toString(toLocalTime(r_8.InspectionDate), "dd.MM.yyyy"));
                            break;
                        }
                        default:
                            if (nextDueDate_1 == null) {
                                dateText = t("inspection_status.never");
                            }
                            else {
                                const d_2 = nextDueDate_1;
                                dateText = concat(t("inspection_status.next_due"), ": ", ...toString(toLocalTime(d_2), "dd.MM.yyyy"));
                            }
                    }
                    break;
                }
                case 3: {
                    dateText = t("inspection_status.never");
                    break;
                }
                default:
                    if (nextDueDate_1 == null) {
                        dateText = t("inspection_status.all_ok");
                    }
                    else {
                        const d = nextDueDate_1;
                        dateText = concat(t("inspection_status.next_due"), ": ", ...toString(toLocalTime(d), "dd.MM.yyyy"));
                    }
            }
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "drop-shadow-lg", "p-4"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex-shrink-0"])], (elems = [createElement(ColoredDot, {
                Color: statusColor,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", {
                className: join(" ", ["text-sm"]),
                children: dateText,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", {
                className: join(" ", ["text-sm", "font-semibold", "mt-3"]),
                children: matchValue_1[0].Name,
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }, templateDetails)));
        content = react.createElement(react.Fragment, {}, ...xs_5);
    }
    return Box((Title_1 = t("inspection_status.title"), {
        AdditionalInformation: t("inspection_status.to_inspections"),
        ContentElement: content,
        OnClick: () => {
            selectAndScroll(props.SetCurrentSelectedLink, "inspections-section-id");
        },
        Title: Title_1,
    }));
}

export function ToolShortDetails(props) {
    let elems_18;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsSwitchStorageDialogOpen = patternInput_1[1];
    const isSwitchStorageDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsChangeReturnDateDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setIsReleaseDateDialogOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsChangeBusinessUnitDialogOpen = patternInput_4[1];
    let storageLocation;
    const matchValue = props.Tool.StorageInformation.Location;
    storageLocation = ((matchValue == null) ? "" : concat("(", matchValue.Name, ...")"));
    return reactElement("div", createObj(singleton_1((elems_18 = toList(delay(() => append(singleton(createElement(ChangeStorageDialog, {
        IsOpen: isSwitchStorageDialogOpen,
        OnClose: () => {
            setIsSwitchStorageDialogOpen(false);
        },
        Storages: props.Storages,
        SuccessCallback: () => {
            toast.success(t("general.saved_successfully"));
            setIsSwitchStorageDialogOpen(false);
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
        UserData: props.UserData,
    })), delay(() => append(singleton(createElement(ChangeReturnDateDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsChangeReturnDateDialogOpen(false);
        },
        SuccessCallback: () => {
            toast.success(t("general.saved_successfully"));
            setIsChangeReturnDateDialogOpen(false);
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
    })), delay(() => append(singleton(createElement(ChangeBusinessUnitDialog, {
        IsOpen: patternInput_4[0],
        OnClose: () => {
            setIsChangeBusinessUnitDialogOpen(false);
        },
        OnSuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        RequestTargetId: new RequestTargetId_1(0, [props.Tool.Id]),
        SelectedBusinessUnitId: unwrap(props.Tool.BusinessUnitId),
        StorageId: props.Tool.StorageInformation.StorageId,
        Storages: props.Storages,
    })), delay(() => append(singleton(createElement(ReleaseDateDialog, {
        IsOpen: patternInput_3[0],
        OnClose: () => {
            setIsReleaseDateDialogOpen(false);
        },
        SuccessCallback: () => {
            toast.success(t("general.saved_successfully"));
            setIsReleaseDateDialogOpen(false);
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
    })), delay(() => {
        let elems_2, elems_1, elems, matchValue_1, matchValue_2, matchValue_4, maintenanceEndDate;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_2 = [reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
            children: t("general.state"),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems = [createElement(ColoredDot, {
            Color: (matchValue_1 = props.Tool.State, (matchValue_1 === "inMaintenance") ? "orange" : ((matchValue_1 === "retired") ? "red" : ((matchValue_1 === "lost") ? "red" : "green"))),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: concat((matchValue_2 = props.Tool.State, (matchValue_2 === "inMaintenance") ? t("general.in_maintenance") : ((matchValue_2 === "retired") ? t("general.retired") : ((matchValue_2 === "lost") ? t("general.lost") : t("general.active")))), " ", ...((matchValue_4 = props.Tool.MaintenanceEndDate, (props.Tool.State === "inMaintenance") ? ((matchValue_4 != null) ? ((maintenanceEndDate = matchValue_4, ((("(" + t("tool.maintenance_planned_end_date")) + ": ") + toString(toLocalTime(maintenanceEndDate), "dd.MM.yyyy")) + ")")) : defaultArg(map_1((date) => (("(" + toString(toLocalTime(date), "dd.MM.yyyy")) + ")"), props.Tool.StateDate), "")) : defaultArg(map_1((date) => (("(" + toString(toLocalTime(date), "dd.MM.yyyy")) + ")"), props.Tool.StateDate), "")))),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_4, elems_3;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [reactElement("div", {
                className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                children: t("tool.assgined_to"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], ["data-test-id", "tool-assigned-to-test-id"], (elems_3 = toList(delay(() => {
                const matchValue_6 = props.Tool.AssignedReceiverInformation;
                if (matchValue_6 != null) {
                    const assignedReceiver = matchValue_6;
                    let receiverType;
                    const matchValue_7 = assignedReceiver.ReceiverTypeName;
                    receiverType = ((matchValue_7.tag === 1) ? t("receivers.employee") : ((matchValue_7.tag === 2) ? t("receivers.externalperson") : ((matchValue_7.tag === 3) ? t("receivers.subcontractor") : ((matchValue_7.tag === 4) ? t("receivers.room") : ((matchValue_7.tag === 5) ? t("receivers.project") : ((matchValue_7.tag === 6) ? t("receivers.constructionsite") : ((matchValue_7.tag === 7) ? t("receivers.student") : ((matchValue_7.tag === 8) ? t("receivers.school_class") : ((matchValue_7.tag === 9) ? t("receivers.vehicles") : ((matchValue_7.tag === 10) ? t("receivers.api_receiver") : t("receivers.user")))))))))));
                    const matchValue_8 = props.UserData.Role;
                    switch (matchValue_8) {
                        case "user":
                            return singleton(createElement(TextValue, {
                                FontWeight: "normal",
                                TestId: "",
                                Text: concat(assignedReceiver.ReceiverName, " (", receiverType, ...")"),
                            }));
                        default:
                            return singleton(createElement(TextButton, {
                                ComponentState: "enabled",
                                Label: concat(assignedReceiver.ReceiverName, " (", receiverType, ...")"),
                                OnClick: () => {
                                    RouterModule_nav(singleton_1(concat("/receivers/", ...assignedReceiver.AssignedReceiverId)), 1, 1);
                                },
                                TestId: "assigned-receiver-text-button-test-id",
                                Variant: "blueButton",
                            }));
                    }
                }
                else {
                    return singleton(createElement(TextValue, {
                        FontWeight: "normal",
                        TestId: "",
                        Text: t("tool.not_assigned"),
                    }));
                }
            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                let matchValue_9, assignedReceiver_1, elems_6, elems_5, Label_1, matchValue_10, matchValue_11;
                return append(isFeatureEnabled(new Feature(16, [])) ? ((props.CustomerConfiguration.IsReleaseDateEnabled && (props.Tool.AssignedSet == null)) ? ((matchValue_9 = props.Tool.AssignedReceiverInformation, (matchValue_9 != null) ? ((assignedReceiver_1 = matchValue_9, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_6 = [reactElement("div", {
                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                    children: t("general.release_date"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], ["data-test-id", "tool-release-date-test-id"], (elems_5 = [createElement(TextButton, (Label_1 = ((matchValue_10 = assignedReceiver_1.ReleaseDate, (matchValue_10 != null) ? toString(toLocalTime(matchValue_10), "dd.MM.yyyy") : t("general.no_release_date_set"))), {
                    ComponentState: (matchValue_11 = props.UserData.Role, (matchValue_11 === "administrator") ? "enabled" : ((matchValue_11 === "toolManager") ? (((assignedReceiver_1.AssignedReceiverId === props.UserData.UserId) ? true : contains(props.UserData.UserId, props.Tool.StorageInformation.AssignedUserIds, {
                        Equals: (x, y) => (x === y),
                        GetHashCode: (x) => (stringHash(x) | 0),
                    })) ? "enabled" : "disabled") : ((matchValue_11 === "user") ? ((assignedReceiver_1.AssignedReceiverId === props.UserData.UserId) ? "enabled" : "disabled") : "enabled"))),
                    Label: Label_1,
                    OnClick: () => {
                        setIsReleaseDateDialogOpen(true);
                    },
                    TestId: "release-date-receiver-text-button-test-id",
                    Variant: "blueButton",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))))) : (empty()))) : empty()) : empty(), delay(() => {
                    let matchValue_12, assignedReceiver_2, elems_8, elems_7, Label_2, matchValue_13, matchValue_14;
                    return append((matchValue_12 = props.Tool.AssignedReceiverInformation, (matchValue_12 != null) ? ((assignedReceiver_2 = matchValue_12, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_8 = [reactElement("div", {
                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                        children: t("tool.planned_return_date"),
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], ["data-test-id", "tool-planned-return-date-test-id"], (elems_7 = [createElement(TextButton, (Label_2 = ((matchValue_13 = assignedReceiver_2.PlannedReturnDate, (matchValue_13 != null) ? toString(toLocalTime(matchValue_13), "dd.MM.yyyy") : t("general.no_planned_return_date_set"))), {
                        ComponentState: (matchValue_14 = props.UserData.Role, (matchValue_14 === "toolManager") ? "enabled" : ((matchValue_14 === "administrator") ? "enabled" : ((matchValue_14 === "user") ? "disabled" : "enabled"))),
                        Label: Label_2,
                        OnClick: () => {
                            setIsChangeReturnDateDialogOpen(true);
                        },
                        TestId: "planned-return-date-receiver-text-button-test-id",
                        Variant: "blueButton",
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))))) : (empty())), delay(() => {
                        let elems_10, elems_9;
                        return append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_10 = [reactElement("div", {
                            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                            children: t("business_units.business_unit"),
                        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_9 = toList(delay(() => {
                            let Label_3, matchValue_21, matchValue_19;
                            const matchValue_15 = props.Tool.BusinessUnitName;
                            if (matchValue_15 == null) {
                                const matchValue_20 = props.UserData.Role;
                                switch (matchValue_20) {
                                    case "toolManager":
                                    case "user":
                                        return singleton(defaultOf());
                                    default:
                                        return singleton(createElement(TextButton, (Label_3 = t("business_units.no_business_unit_set"), {
                                            ComponentState: (matchValue_21 = props.UserData.Role, (matchValue_21 === "toolManager") ? "enabled" : ((matchValue_21 === "administrator") ? "enabled" : ((matchValue_21 === "user") ? "disabled" : "enabled"))),
                                            Label: Label_3,
                                            OnClick: () => {
                                                setIsChangeBusinessUnitDialogOpen(true);
                                            },
                                            TestId: "change-business-unit-text-button-test-id",
                                            Variant: "blueButton",
                                        })));
                                }
                            }
                            else {
                                const businessUnitName = matchValue_15;
                                const matchValue_16 = props.UserData.Role;
                                let matchResult;
                                switch (matchValue_16) {
                                    case "system": {
                                        matchResult = 0;
                                        break;
                                    }
                                    case "toolManager":
                                    case "user": {
                                        matchResult = 1;
                                        break;
                                    }
                                    default:
                                        if (isEmpty(props.CurrentUser.BusinessUnitIds)) {
                                            matchResult = 0;
                                        }
                                        else {
                                            matchResult = 1;
                                        }
                                }
                                switch (matchResult) {
                                    case 0:
                                        return singleton(createElement(TextButton, {
                                            ComponentState: (matchValue_19 = props.UserData.Role, (matchValue_19 === "toolManager") ? "enabled" : ((matchValue_19 === "administrator") ? "enabled" : ((matchValue_19 === "user") ? "disabled" : "enabled"))),
                                            Label: businessUnitName,
                                            OnClick: () => {
                                                setIsChangeBusinessUnitDialogOpen(true);
                                            },
                                            TestId: "change-business-unit-text-button-test-id",
                                            Variant: "blueButton",
                                        }));
                                    default:
                                        return singleton(createElement(TextValue, {
                                            FontWeight: "normal",
                                            TestId: "tool-details-business-unit",
                                            Text: businessUnitName,
                                        }));
                                }
                            }
                        })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty()) : empty(), delay(() => {
                            let elems_12;
                            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_12 = toList(delay(() => append(singleton(reactElement("div", {
                                className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                children: t("general.storage"),
                            })), delay(() => {
                                let elems_11;
                                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_11 = [createElement(TextValue, {
                                    FontWeight: "normal",
                                    TestId: "",
                                    Text: concat(props.Tool.StorageInformation.StorageName, " ", ...storageLocation),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
                                    const matchValue_22 = props.UserData.Role;
                                    switch (matchValue_22) {
                                        case "user": {
                                            return empty();
                                        }
                                        default: {
                                            const matchValue_23 = props.Tool.State;
                                            switch (matchValue_23) {
                                                case "lost":
                                                case "retired": {
                                                    return empty();
                                                }
                                                default:
                                                    return singleton(createElement(TextButton, {
                                                        ComponentState: "enabled",
                                                        Label: t("tool.switch_storage"),
                                                        OnClick: () => {
                                                            setIsSwitchStorageDialogOpen(!isSwitchStorageDialogOpen);
                                                        },
                                                        TestId: "switch-storage-text-button-test-id",
                                                        Variant: "blueButton",
                                                    }));
                                            }
                                        }
                                    }
                                }));
                            })))), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                                let elems_14, elems_13;
                                return append(!isNullOrWhiteSpace(props.Tool.StorageInformation.StorageSpace) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_14 = [reactElement("div", {
                                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                    children: t("tool.storage_space"),
                                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_13 = [createElement(TextValue, {
                                    FontWeight: "normal",
                                    TestId: "",
                                    Text: props.Tool.StorageInformation.StorageSpace,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))) : empty(), delay(() => {
                                    let matchValue_24, lastSeen, elems_16, elems_15;
                                    return append((matchValue_24 = props.Tool.LastSeen, (matchValue_24 == null) ? (empty()) : ((lastSeen = matchValue_24, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_16 = [reactElement("div", {
                                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                        children: t("general.last_seen"),
                                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_15 = [createElement(TextValue, {
                                        FontWeight: "normal",
                                        TestId: "",
                                        Text: `${toString(toLocalTime(lastSeen.ScannedAt), "dd.MM.yyyy HH:mm")} ${t("general.last_seen_by")} ${lastSeen.ScannedByUserName} (${(lastSeen.ScanMethod === "nfc_tag") ? t("general.nfc_tag") : t("general.qr_code")})`,
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))))))), delay(() => {
                                        let elems_17;
                                        return isFeatureEnabled(new Feature(3, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_17 = [createElement(QuickOverviewList, {
                                            Currency: props.CustomerConfiguration.Currency,
                                            Elements: {
                                                CommercialData: unwrap(props.Tool.CommercialData),
                                                Custom: toList(delay(() => {
                                                    let Label_5;
                                                    return append(singleton((Label_5 = t("tool.manufacturer"), {
                                                        Group: t("general.master_data"),
                                                        Key: "tool-manufacturer-fav-field",
                                                        Label: Label_5,
                                                        Value: props.Tool.MasterData.Manufacturer,
                                                    })), delay(() => {
                                                        let Label_6;
                                                        return append(singleton((Label_6 = t("tool.model"), {
                                                            Group: t("general.master_data"),
                                                            Key: "tool-model-fav-field",
                                                            Label: Label_6,
                                                            Value: props.Tool.MasterData.Model,
                                                        })), delay(() => {
                                                            let Label_7;
                                                            return append(singleton((Label_7 = t("tool.serial_number"), {
                                                                Group: t("general.master_data"),
                                                                Key: "tool-serialnumber-fav-field",
                                                                Label: Label_7,
                                                                Value: props.Tool.MasterData.SerialNumber,
                                                            })), delay(() => {
                                                                let Label_8;
                                                                return append(singleton((Label_8 = t("tool.displayname"), {
                                                                    Group: t("general.master_data"),
                                                                    Key: "tool-displayname-fav-field",
                                                                    Label: Label_8,
                                                                    Value: props.Tool.MasterData.DisplayName,
                                                                })), delay(() => {
                                                                    let Label_9;
                                                                    return append(singleton((Label_9 = t("tool.inventory_number"), {
                                                                        Group: t("general.master_data"),
                                                                        Key: "tool-inventorynumber-fav-field",
                                                                        Label: Label_9,
                                                                        Value: props.Tool.MasterData.InventoryNumber,
                                                                    })), delay(() => {
                                                                        let Label_10;
                                                                        return append(singleton((Label_10 = t("general.comment"), {
                                                                            Group: t("general.master_data"),
                                                                            Key: "tool-comment-fav-field",
                                                                            Label: Label_10,
                                                                            Value: props.Tool.MasterData.Comment,
                                                                        })), delay(() => {
                                                                            let matchValue_27, Label_11;
                                                                            return append((props.UserData.Customer.tag === 1) ? ((matchValue_27 = props.Tool.CustomerSpecific, (matchValue_27.tag === 0) ? (empty()) : ((matchValue_27.tag === 1) ? singleton((Label_11 = t("tool.prinzing.check_number"), {
                                                                                Group: t("general.master_data"),
                                                                                Key: "tool-prinzing-check-number-fav-field",
                                                                                Label: Label_11,
                                                                                Value: matchValue_27.fields[0].CheckNumber,
                                                                            })) : (empty())))) : (empty()), delay(() => {
                                                                                let Label_12, Value_7;
                                                                                return append(singleton((Label_12 = t("tool.last_check"), (Value_7 = defaultArg(map_1((value_68) => toString(toLocalTime(value_68), "dd.MM.yyyy"), props.Tool.MasterData.LastInspectionDate), ""), {
                                                                                    Group: t("general.master_data"),
                                                                                    Key: "tool-last-inspection-data-fav-field",
                                                                                    Label: Label_12,
                                                                                    Value: Value_7,
                                                                                }))), delay(() => {
                                                                                    let Label_13, Value_8;
                                                                                    return singleton((Label_13 = t("tool.next_inspection"), (Value_8 = defaultArg(map_1((value_70) => toString(toLocalTime(value_70), "dd.MM.yyyy"), props.Tool.MasterData.NextInspectionDate), ""), {
                                                                                        Group: t("general.master_data"),
                                                                                        Key: "tool-next-inspection-data-fav-field",
                                                                                        Label: Label_13,
                                                                                        Value: Value_8,
                                                                                    })));
                                                                                }));
                                                                            }));
                                                                        }));
                                                                    }));
                                                                }));
                                                            }));
                                                        }));
                                                    }));
                                                })),
                                                CustomProperties: props.Tool.CustomProperties,
                                            },
                                            IsDialogOpen: props.QuickOverviewDialog.IsOpen,
                                            IsLoading: props.QuickOverviewDialog.IsLoading,
                                            OnSave: (updatedVisibleKeys) => {
                                                props.Dispatch(new Msg(0, [updatedVisibleKeys]));
                                            },
                                            SetDialogOpen: (_arg_14) => {
                                                props.Dispatch(new Msg(1, []));
                                            },
                                            UserData: props.UserData,
                                            VisibleKeys: props.UserConfiguration.QuickOverviewConfiguration.ToolViewVisibleFieldKeys,
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))) : empty();
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_18))]))));
}

export function ToolDetailsActions(props) {
    let elems_4;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsReservationDialogOpen = patternInput_1[1];
    const isReservationDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsAssignDialogOpen = patternInput_2[1];
    const isAssignDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsUnassignDialogOpen = patternInput_3[1];
    const isUnassignDialogOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState(false);
    const setIsProblemReportOpen = patternInput_4[1];
    const isCreateProblemReportOpen = patternInput_4[0];
    const patternInput_5 = reactApi.useState(false);
    const setIsReturnNotificationDialogOpen = patternInput_5[1];
    const isReturnNotificationDialogOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setIsSelfServiceAssignDialogOpen = patternInput_6[1];
    const isSelfServiceAssignDialogOpen = patternInput_6[0];
    const patternInput_7 = reactApi.useState(false);
    const setIsSelfServiceReturnDialogOpen = patternInput_7[1];
    const isSelfServiceReturnDialogOpen = patternInput_7[0];
    const patternInput_8 = reactApi.useState(false);
    const setIsStartProcedureDialogOpen = patternInput_8[1];
    const isStartProcedureDialogOpen = patternInput_8[0];
    const patternInput_9 = reactApi.useState(false);
    const setIsInMaintenanceStateDialogOpen = patternInput_9[1];
    const patternInput_10 = reactApi.useState(false);
    const setIsActiveStateDialogOpen = patternInput_10[1];
    const patternInput_11 = reactApi.useState(false);
    const setIsLostStateDialogOpen = patternInput_11[1];
    const patternInput_12 = reactApi.useState(false);
    const setIsRetiredStateDialogOpen = patternInput_12[1];
    const patternInput_13 = reactApi.useState(false);
    const setIsAssignFromReceiverToReceiverDialogOpen = patternInput_13[1];
    const isAssignFromReceiverToReceiverDialogOpen = patternInput_13[0];
    const assignButtonOnboardingWrap = (el) => reactElement("div", {
        "data-test-id": "onboarding-tour-tool-assign-button-anchor",
        className: join(" ", ["inline-flex", "items-center"]),
        children: reactApi.Children.toArray([el]),
    });
    const actionButtons = toList(delay(() => {
        let Label_2, Label;
        return (props.Tool.AssignedReceiverInformation == null) ? ((props.Tool.State === "active") ? singleton(assignButtonOnboardingWrap(createElement(TextButton, (Label_2 = t("general.assign"), {
            ComponentState: "enabled",
            Icon: Following(),
            Label: Label_2,
            OnClick: () => {
                setIsAssignDialogOpen(true);
            },
            TestId: "tool-tooldetail-assign-button",
            Variant: "default",
        })))) : empty()) : append(singleton(createElement(TextButton, (Label = t("general.take_back"), {
            ComponentState: "enabled",
            Icon: Followers(),
            Label: Label,
            OnClick: () => {
                setIsUnassignDialogOpen(true);
            },
            TestId: "tool-tooldetail-unassign-button",
            Variant: "default",
        }))), delay(() => {
            let Label_1;
            return ((props.Tool.State !== "lost") ? true : (props.Tool.State !== "retired")) ? singleton(assignButtonOnboardingWrap(createElement(TextButton, (Label_1 = t("general.assign"), {
                ComponentState: "enabled",
                Icon: Following(),
                Label: Label_1,
                OnClick: () => {
                    setIsAssignFromReceiverToReceiverDialogOpen(true);
                },
                TestId: "tool-tooldetail-assign-receiver-to-receiver-button",
                Variant: "default",
            })))) : empty();
        }));
    }));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-7", "mb-12"])], (elems_4 = toList(delay(() => append(isReservationDialogOpen ? singleton(createElement(NewReservation_AddToolReservationDialog, {
        IsOpen: isReservationDialogOpen,
        OnClose: () => {
            setIsReservationDialogOpen(false);
        },
        SuccessCallback: () => {
            selectAndScroll(props.SetCurrentSelectedLink, "reservations-section-id");
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
        UserData: props.UserData,
    })) : empty(), delay(() => append(isAssignDialogOpen ? singleton(createElement(AssignToolDialog, {
        IsOpen: isAssignDialogOpen,
        OnClose: () => {
            setIsAssignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
        UserId: props.UserId,
    })) : empty(), delay(() => append(isUnassignDialogOpen ? singleton(createElement(UnassignDialog, {
        IsOpen: isUnassignDialogOpen,
        OnClose: () => {
            setIsUnassignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
        UserId: props.UserId,
    })) : empty(), delay(() => append(isReturnNotificationDialogOpen ? singleton(createElement(ReturnToolNotificationDialog, {
        IsOpen: isReturnNotificationDialogOpen,
        OnClose: () => {
            setIsReturnNotificationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
    })) : empty(), delay(() => append(isSelfServiceAssignDialogOpen ? singleton(createElement(SelfServiceAssignToolDialog, {
        IsOpen: isSelfServiceAssignDialogOpen,
        OnClose: () => {
            setIsSelfServiceAssignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
        UserId: props.UserId,
    })) : empty(), delay(() => append(isSelfServiceReturnDialogOpen ? singleton(createElement(SelfServiceReturnToolDialog, {
        IsOpen: isSelfServiceReturnDialogOpen,
        OnClose: () => {
            setIsSelfServiceReturnDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
    })) : empty(), delay(() => append(isCreateProblemReportOpen ? singleton(createElement(ToolCreateProblemReportDialog, {
        IsOpen: isCreateProblemReportOpen,
        OnClose: () => {
            setIsProblemReportOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        ToolId: new ToolId_4(parse(props.Tool.Id)),
        UserId: props.UserId,
    })) : empty(), delay(() => append(isStartProcedureDialogOpen ? singleton(createElement(StartProcedureDialog, {
        IsOpen: isStartProcedureDialogOpen,
        OnClose: () => {
            setIsStartProcedureDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
    })) : empty(), delay(() => {
        let matchValue_1;
        return append((matchValue_1 = props.Tool.AssignedReceiverInformation, (matchValue_1 == null) ? (empty()) : (isAssignFromReceiverToReceiverDialogOpen ? singleton(createElement(OpenDialog, {
            AssignedReceiverId: matchValue_1.AssignedReceiverId,
            IsOpen: isAssignFromReceiverToReceiverDialogOpen,
            OnClose: () => {
                setIsAssignFromReceiverToReceiverDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            Tool: props.Tool,
        })) : empty())), delay(() => append(singleton(createElement(ToolStateChangeDialog, {
            IsOpen: patternInput_9[0],
            OnClose: () => {
                setIsInMaintenanceStateDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            Tool: props.Tool,
            ToolState: "inMaintenance",
        })), delay(() => append(singleton(createElement(ToolStateChangeDialog, {
            IsOpen: patternInput_10[0],
            OnClose: () => {
                setIsActiveStateDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            Tool: props.Tool,
            ToolState: "active",
        })), delay(() => append(singleton(createElement(ToolStateChangeDialog, {
            IsOpen: patternInput_12[0],
            OnClose: () => {
                setIsRetiredStateDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            Tool: props.Tool,
            ToolState: "retired",
        })), delay(() => append(singleton(createElement(ToolStateChangeDialog, {
            IsOpen: patternInput_11[0],
            OnClose: () => {
                setIsLostStateDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            Tool: props.Tool,
            ToolState: "lost",
        })), delay(() => {
            let elems_3, elems_1, elems_2;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "grow", "justify-between"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4"])], (elems_1 = toList(delay(() => {
                let Label_3;
                return append(((props.Tool.State === "active") ? true : (props.Tool.State === "inMaintenance")) ? singleton(createElement(TextButton, (Label_3 = t("dialog.reservation.btn_title"), {
                    ComponentState: "enabled",
                    Icon: Calendar_Add(),
                    Label: Label_3,
                    OnClick: () => {
                        setIsReservationDialogOpen(true);
                    },
                    TestId: "tool-tooldetail-reservate-button",
                    Variant: "default",
                }))) : empty(), delay(() => {
                    let Label_4, Label_5, Label_6;
                    const matchValue_2 = props.UserData.Role;
                    switch (matchValue_2) {
                        case "toolManager":
                        case "user":
                            if (contains(props.UserData.UserId, props.Tool.StorageInformation.AssignedUserIds, {
                                Equals: (x, y) => (x === y),
                                GetHashCode: (x) => (stringHash(x) | 0),
                            })) {
                                return actionButtons;
                            }
                            else {
                                const storage = tryFind((s) => (unwrapStorageId(s.Id) === props.Tool.StorageInformation.StorageId), props.Storages);
                                let isSelfServiceUser;
                                if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                                    isSelfServiceUser = true;
                                }
                                else if (storage == null) {
                                    isSelfServiceUser = false;
                                }
                                else {
                                    const s_1 = storage;
                                    isSelfServiceUser = (s_1.IsSelfService ? true : contains(props.UserData.UserId, s_1.AccessByUser, {
                                        Equals: (x_1, y_1) => (x_1 === y_1),
                                        GetHashCode: (x_1) => (stringHash(x_1) | 0),
                                    }));
                                }
                                const matchValue_3 = props.Tool.AssignedReceiverInformation;
                                let matchResult, receiver_1;
                                if (matchValue_3 != null) {
                                    if (matchValue_3.AssignedReceiverId === props.UserData.UserId) {
                                        matchResult = 1;
                                        receiver_1 = matchValue_3;
                                    }
                                    else {
                                        matchResult = 2;
                                    }
                                }
                                else if (isSelfServiceUser && (props.Tool.State === "active")) {
                                    matchResult = 0;
                                }
                                else {
                                    matchResult = 2;
                                }
                                switch (matchResult) {
                                    case 0:
                                        return singleton(createElement(TextButton, (Label_4 = t("general.self_service_assign"), {
                                            ComponentState: "enabled",
                                            Icon: Following(),
                                            Label: Label_4,
                                            OnClick: () => {
                                                setIsSelfServiceAssignDialogOpen(true);
                                            },
                                            TestId: "tool-tooldetail-self-service-assign-button",
                                            Variant: "default",
                                        })));
                                    case 1:
                                        return (isSelfServiceUser && props.CustomerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification) ? singleton(createElement(TextButton, (Label_5 = t("general.self_service_return"), {
                                            ComponentState: "enabled",
                                            Icon: Followers(),
                                            Label: Label_5,
                                            OnClick: () => {
                                                setIsSelfServiceReturnDialogOpen(true);
                                            },
                                            TestId: "tool-tooldetail-self-service-return-button",
                                            Variant: "default",
                                        }))) : singleton(createElement(TextButton, (Label_6 = t("general.request_return"), {
                                            ComponentState: "enabled",
                                            Icon: Followers(),
                                            Label: Label_6,
                                            OnClick: () => {
                                                setIsReturnNotificationDialogOpen(true);
                                            },
                                            TestId: "tool-tooldetail-return-notification-button",
                                            Variant: "default",
                                        })));
                                    default: {
                                        return empty();
                                    }
                                }
                            }
                        default:
                            return actionButtons;
                    }
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "items-center"])], (elems_2 = toList(delay(() => {
                let Label_7;
                return append((props.HasManualHooks && ((props.Tool.State === "active") ? true : (props.Tool.State === "inMaintenance"))) ? singleton(createElement(TextButton, (Label_7 = t("procedure.manual_start.button"), {
                    ComponentState: "enabled",
                    Icon: Order_History(),
                    Label: Label_7,
                    OnClick: () => {
                        setIsStartProcedureDialogOpen(true);
                    },
                    TestId: "tool-tooldetail-start-procedure-button",
                    Variant: "default",
                }))) : empty(), delay(() => {
                    let Label_9, matchValue_5, Icon_11, Icon_12, Icon_13, Icon_14, Icon_15, Icon_8, Icon_9, Icon_10;
                    const matchValue_4 = props.UserData.Role;
                    switch (matchValue_4) {
                        case "user":
                            return singleton(createElement(TextButton, (Label_9 = t("dialog.problem_report.btn_title"), {
                                ComponentState: "enabled",
                                Icon: Shipment_Warning(),
                                Label: Label_9,
                                OnClick: () => {
                                    setIsProblemReportOpen(true);
                                },
                                TestId: "tool-create-problem-report-button",
                                Variant: "default",
                            })));
                        default:
                            return singleton(createElement(TextDropdownButton, {
                                Classes: empty_1(),
                                ComponentState: "enabled",
                                DisplayArrow: true,
                                DisplayDivider: false,
                                Elements: (matchValue_5 = props.Tool.State, (matchValue_5 === "inMaintenance") ? ofArray([(Icon_11 = Shipment_Check(), {
                                    DisplayName: t("tool.state_active"),
                                    Icon: unwrap(Icon_11),
                                    OnClick: () => {
                                        setIsActiveStateDialogOpen(true);
                                    },
                                }), (Icon_12 = Shipment_Delivery_Fail(), {
                                    DisplayName: t("general.retired"),
                                    Icon: unwrap(Icon_12),
                                    OnClick: () => {
                                        setIsRetiredStateDialogOpen(true);
                                    },
                                }), (Icon_13 = Shipment_Search(), {
                                    DisplayName: t("general.lost"),
                                    Icon: unwrap(Icon_13),
                                    OnClick: () => {
                                        setIsLostStateDialogOpen(true);
                                    },
                                })]) : ((matchValue_5 === "lost") ? singleton_1((Icon_14 = Shipment_Check(), {
                                    DisplayName: t("tool.state_active"),
                                    Icon: unwrap(Icon_14),
                                    OnClick: () => {
                                        setIsActiveStateDialogOpen(true);
                                    },
                                })) : ((matchValue_5 === "retired") ? singleton_1((Icon_15 = Shipment_Check(), {
                                    DisplayName: t("tool.state_active"),
                                    Icon: unwrap(Icon_15),
                                    OnClick: () => {
                                        setIsActiveStateDialogOpen(true);
                                    },
                                })) : ofArray([(Icon_8 = Shipment_Time(), {
                                    DisplayName: t("tool.state_in_maintenance"),
                                    Icon: unwrap(Icon_8),
                                    OnClick: () => {
                                        setIsInMaintenanceStateDialogOpen(true);
                                    },
                                }), (Icon_9 = Shipment_Delivery_Fail(), {
                                    DisplayName: t("general.reject"),
                                    Icon: unwrap(Icon_9),
                                    OnClick: () => {
                                        setIsRetiredStateDialogOpen(true);
                                    },
                                }), (Icon_10 = Shipment_Search(), {
                                    DisplayName: t("general.report_lost"),
                                    Icon: unwrap(Icon_10),
                                    OnClick: () => {
                                        setIsLostStateDialogOpen(true);
                                    },
                                })])))),
                                Label: t("general.change_status"),
                                TestId: "tool-tooldetail-change-status-dropdown",
                            }));
                    }
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
        }))))))))));
    })))))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function MasterDataSection(props) {
    let elems_4, elems_3;
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton_1((elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-20", "h-30"])], (elems_3 = toList(delay(() => {
        let elems_1, Title, elems;
        return append(singleton(reactElement("div", createObj(singleton_1((elems_1 = [createElement(PropertyList, (Title = t("general.master_data"), {
            Properties: toList(delay(() => append(singleton({
                Label: t("tool.manufacturer"),
                TestId: "master-data-manufacturer",
                Value: props.Tool.MasterData.Manufacturer,
            }), delay(() => append(singleton({
                Label: t("tool.model"),
                TestId: "master-data-model",
                Value: props.Tool.MasterData.Model,
            }), delay(() => append(singleton({
                Label: t("tool.serial_number"),
                TestId: "master-data-serial-number",
                Value: props.Tool.MasterData.SerialNumber,
            }), delay(() => append(singleton({
                Label: t("tool.displayname"),
                TestId: "master-data-display-name",
                Value: props.Tool.MasterData.DisplayName,
            }), delay(() => append(singleton({
                Label: t("tool.inventory_number"),
                TestId: "master-data-inventory-number",
                Value: props.Tool.MasterData.InventoryNumber,
            }), delay(() => append(singleton({
                Label: t("general.comment"),
                TestId: "master-data-comment",
                Value: props.Tool.MasterData.Comment,
            }), delay(() => append(singleton({
                Label: t("tool.last_check"),
                TestId: "master-data-last-check",
                Value: defaultArg(map_1((lastInspectionDate) => toString(toLocalTime(lastInspectionDate), "dd.MM.yyyy"), props.Tool.MasterData.LastInspectionDate), ""),
            }), delay(() => append(singleton({
                Label: t("tool.next_inspection"),
                TestId: "master-data-next-check",
                Value: defaultArg(map_1((nextInspectionDate) => toString(toLocalTime(nextInspectionDate), "dd.MM.yyyy"), props.Tool.MasterData.NextInspectionDate), ""),
            }), delay(() => {
                if (props.Customer.tag === 1) {
                    const matchValue_1 = props.Tool.CustomerSpecific;
                    switch (matchValue_1.tag) {
                        case 1:
                            return singleton({
                                Label: t("tool.prinzing.check_number"),
                                TestId: "master-data-prinzing-check-number",
                                Value: matchValue_1.fields[0].CheckNumber,
                            });
                        default: {
                            return empty();
                        }
                    }
                }
                else {
                    return empty();
                }
            })))))))))))))))))),
            Title: unwrap(Title),
        })), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-8"])], (elems = [createElement(CustomPropertiesPropertyList, {
            Currency: props.Currency,
            CustomProperties: props.Tool.CustomProperties,
            Title: t("tool.custom_properties"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))), delay(() => {
            let elems_2, Title_2;
            const matchValue_2 = props.Tool.CommercialData;
            if (matchValue_2 == null) {
                return empty();
            }
            else {
                const commercialData = matchValue_2;
                return singleton(reactElement("div", createObj(singleton_1((elems_2 = [createElement(PropertyList, (Title_2 = t("tool.commercial_data"), {
                    Properties: ofArray([{
                        Label: t("general.supplier"),
                        TestId: "commercial-data-supplier",
                        Value: commercialData.Supplier,
                    }, {
                        Label: t("general.supplier_article_number"),
                        TestId: "commercial-data-supplier-article-number",
                        Value: commercialData.SupplierArticleNumber,
                    }, {
                        Label: t("general.purchase_price"),
                        TestId: "commercial-data-purchase-price",
                        Value: price(commercialData.PurchasePrice, props.Currency),
                    }, {
                        Label: t("general.purchase_date"),
                        TestId: "commercial-data-purchase-date",
                        Value: purchaseDate(commercialData.PurchaseDate),
                    }, {
                        Label: t("general.gurantee_date"),
                        TestId: "commercial-data-guarantee-date",
                        Value: purchaseDate(commercialData.WarrantyDate),
                    }, {
                        Label: t("general.comment"),
                        TestId: "commercial-data-comment",
                        Value: commercialData.Comment,
                    }]),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))]))));
}

function AssetIdentifiersSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(AssetIdentifierTable, {
        AssetIdentifiers: (length(props.AssetIdentifiers) > 5) ? take(5, props.AssetIdentifiers) : props.AssetIdentifiers,
        OnAssignQrCode: (arg) => {
            props.Dispatch(new Msg(11, [arg]));
        },
        OnDeleteQrCodes: (arg_1) => {
            props.Dispatch(new Msg(13, [arg_1]));
        },
        UserData: props.UserData,
    })), delay(() => {
        let elems, Title;
        return (length(props.AssetIdentifiers) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, (Title = t("general.qr_codes_and_nfc_tags"), {
            CloseButtonTestId: "",
            Content: createElement(AssetIdentifierTable, {
                AssetIdentifiers: props.AssetIdentifiers,
                OnAssignQrCode: (arg_2) => {
                    props.Dispatch(new Msg(11, [arg_2]));
                },
                OnDeleteQrCodes: (arg_3) => {
                    props.Dispatch(new Msg(13, [arg_3]));
                },
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function BarcodeSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(QrCodeTable, {
        OnAssignQrCode: (arg) => {
            props.Dispatch(new Msg(11, [arg]));
        },
        OnDeleteQrCodes: (arg_1) => {
            props.Dispatch(new Msg(13, [arg_1]));
        },
        QrCodes: (length(props.QRCodeIds) > 5) ? take(5, props.QRCodeIds) : props.QRCodeIds,
        UserData: props.UserData,
    })), delay(() => {
        let elems, Title;
        return (length(props.QRCodeIds) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, (Title = t("general.qr_code"), {
            CloseButtonTestId: "",
            Content: createElement(QrCodeTable, {
                OnAssignQrCode: (qrCode) => {
                    props.Dispatch(new Msg(11, [qrCode]));
                },
                OnDeleteQrCodes: (qrCode_1) => {
                    props.Dispatch(new Msg(13, [qrCode_1]));
                },
                QrCodes: props.QRCodeIds,
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function DocumentSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => {
        let Documents;
        return append(singleton(createElement(DocumentTable, (Documents = ((length(props.Documents) > 5) ? take(5, props.Documents) : props.Documents), {
            AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                EntityId: DocumentId__get_unwrap(dto.Id),
            })])), "none", "button")),
            Documents: Documents,
            OnDownloadFile: (tupledArg) => {
                props.Dispatch(new Msg(27, [tupledArg[0], tupledArg[1]]));
            },
            UploadSuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
                props.Dispatch(new Msg(26, []));
            },
            UploadType: new UploadType_2(0, [props.ToolId]),
            UserData: props.UserData,
        }))), delay(() => {
            let elems, Title;
            return (length(props.Documents) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("general.show_more_data"),
                OnClick: () => {
                    setIsModalOpen(true);
                },
                TestId: "tool-selectcard-tooldetail-showmoredata-button",
                Variant: "blueButton",
            }), createElement(ModalSheet, (Title = t("general.documents"), {
                CloseButtonTestId: "",
                Content: createElement(DocumentTable, {
                    AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto_1) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: DocumentId__get_unwrap(dto_1.Id),
                    })])), "none", "button")),
                    Documents: props.Documents,
                    OnDownloadFile: (tupledArg_1) => {
                        props.Dispatch(new Msg(27, [tupledArg_1[0], tupledArg_1[1]]));
                    },
                    UploadSuccessCallback: () => {
                        props.Dispatch(new Msg(3, []));
                        props.Dispatch(new Msg(26, []));
                    },
                    UploadType: new UploadType_2(0, [props.ToolId]),
                    UserData: props.UserData,
                }),
                Controls: empty_1(),
                IsModalOpen: patternInput_1[0],
                OnClose: () => {
                    setIsModalOpen(false);
                },
                Title: unwrap(Title),
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ReservationSection(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsReservationDialogOpen = patternInput_2[1];
    const isReservationDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReservation = patternInput_3[1];
    const selectedReservation = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedDeleteReservation = patternInput_4[1];
    const selectedDeleteReservation = patternInput_4[0];
    const reservations = sortByDescending((r) => r.StartDate, props.Tool.Reservations, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const xs_2 = toList(delay(() => append(isReservationDialogOpen ? singleton(createElement(NewReservation_AddToolReservationDialog, {
        IsOpen: isReservationDialogOpen,
        OnClose: () => {
            setIsReservationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
        UserData: props.UserData,
    })) : empty(), delay(() => append((selectedReservation != null) ? singleton(createElement(EditReservation_EditToolReservationDialog, {
        IsOpen: selectedReservation != null,
        OnClose: () => {
            setSelectedReservation(undefined);
        },
        Reservation: unwrap(selectedReservation),
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        ToolId: new ToolId_4(parse(props.Tool.Id)),
        UserData: props.UserData,
    })) : empty(), delay(() => append((selectedDeleteReservation != null) ? singleton(createElement(DeleteToolReservationDialog, {
        IsOpen: selectedDeleteReservation != null,
        OnClose: () => {
            setSelectedDeleteReservation(undefined);
        },
        Reservation: unwrap(selectedDeleteReservation),
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        Tool: props.Tool,
        UserData: props.UserData,
    })) : empty(), delay(() => {
        let elems_1;
        const table = (rows) => {
            let TableRows, Options;
            return createElement(Table, (TableRows = toArray(rows), (Options = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["startDate", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "singleRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: [new ColumnDefinition$1("startDate", "", t("general.start_date"), (dto) => (new CellContent(6, [dto.StartDate])), "dateRange", "date"), new ColumnDefinition$1("endDate", "", t("general.end_date"), (dto_1) => (new CellContent(6, [dto_1.EndDate])), "dateRange", "date"), new ColumnDefinition$1("receiverName", "", t("general.receiver"), (dto_2) => (new CellContent(0, [dto_2.ReceiverInformation.ReceiverName])), "none", "text"), new ColumnDefinition$1("reservationName", "", t("general.name"), (dto_3) => (new CellContent(0, [dto_3.Name])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_4) => (new CellContent(0, [dto_4.Description])), "none", "text"), new ColumnDefinition$1("sender", "", t("general.created_by"), (dto_5) => (new CellContent(0, [dto_5.SenderInformation.SenderName])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_6) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                    EntityId: dto_6.Id,
                })])), "none", "button")],
                Controls: toList(delay(() => {
                    let matchValue;
                    return append((matchValue = props.Tool.State, (matchValue === "active") ? append(singleton(new TableControl$1(t("dialog.reservation.btn_title"), Calendar_Add(), (_arg_6) => {
                        setIsReservationDialogOpen(true);
                    }, false, false, "")), delay(() => singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                        const selectedRow = tryHead(rows_1);
                        if (selectedRow == null) {
                        }
                        else {
                            const planning = selectedRow;
                            const matchValue_1 = props.UserData.Role;
                            switch (matchValue_1) {
                                case "user": {
                                    if (planning.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                        setSelectedReservation(planning);
                                    }
                                    break;
                                }
                                default:
                                    setSelectedReservation(planning);
                            }
                        }
                    }, true, false, "")))) : ((matchValue === "lost") ? (empty()) : ((matchValue === "retired") ? (empty()) : append(singleton(new TableControl$1(t("dialog.reservation.btn_title"), Calendar_Add(), (_arg_6) => {
                        setIsReservationDialogOpen(true);
                    }, false, false, "")), delay(() => singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                        const selectedRow = tryHead(rows_1);
                        if (selectedRow == null) {
                        }
                        else {
                            const planning = selectedRow;
                            const matchValue_1 = props.UserData.Role;
                            switch (matchValue_1) {
                                case "user": {
                                    if (planning.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                        setSelectedReservation(planning);
                                    }
                                    break;
                                }
                                default:
                                    setSelectedReservation(planning);
                            }
                        }
                    }, true, false, ""))))))), delay(() => singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_2) => {
                        const selectedRow_1 = tryHead(rows_2);
                        if (selectedRow_1 == null) {
                        }
                        else {
                            const planning_1 = selectedRow_1;
                            const matchValue_2 = props.UserData.Role;
                            switch (matchValue_2) {
                                case "user": {
                                    if (planning_1.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                        setSelectedDeleteReservation(planning_1);
                                    }
                                    break;
                                }
                                default:
                                    setSelectedDeleteReservation(planning_1);
                            }
                        }
                    }, true, false, ""))));
                })),
                Options: Options,
                TableKey: "not-defined-table",
                TableRows: TableRows,
            })));
        };
        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(table((length(reservations) > 5) ? take(5, reservations) : reservations)), delay(() => {
            let elems;
            return (length(reservations) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("general.show_more_data"),
                OnClick: () => {
                    setIsModalOpen(true);
                },
                TestId: "tool-reservations-showmoredata-button",
                Variant: "blueButton",
            }), createElement(ModalSheet, {
                CloseButtonTestId: "",
                Content: table(reservations),
                Controls: empty_1(),
                IsModalOpen: patternInput_1[0],
                OnClose: () => {
                    setIsModalOpen(false);
                },
                Title: t("navbar.reservation"),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
    }))))))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

function AppointmentSection(props) {
    const t = useTranslation()[0];
    const now = date_3(utcNow());
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsReminderDialogOpen = patternInput_2[1];
    const isReminderDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReminderToConfirm = patternInput_3[1];
    const selectedReminderToConfirm = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedReminder = patternInput_4[1];
    const selectedReminder = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setSelectedDeleteReminder = patternInput_5[1];
    const selectedDeleteReminder = patternInput_5[0];
    const patternInput_6 = reactApi.useState(undefined);
    const setSelectedReminderForInspection = patternInput_6[1];
    const reminders = sortByDescending((r) => r.Date, props.Tool.ReminderDates, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const xs_6 = toList(delay(() => {
        let matchValue, reminder, ToolId;
        return append((matchValue = patternInput_6[0], (matchValue == null) ? (empty()) : ((reminder = matchValue, singleton(createElement(OpenDialog_1, (ToolId = (new ToolId_4(parse(props.Tool.Id))), {
            InspectionTemplates: props.InspectionTemplates,
            IsOpen: true,
            OnClose: () => {
                setSelectedReminderForInspection(undefined);
            },
            Reminder: reminder,
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
                props.Dispatch(new Msg(40, []));
                props.Dispatch(new Msg(26, []));
            },
            ToolCategoryIds: map((c) => c.CategoryId, props.Tool.Categories),
            ToolId: ToolId,
        })))))), delay(() => append(isReminderDialogOpen ? singleton(createElement(NewReminder_OpenDialog, {
            IsOpen: isReminderDialogOpen,
            OnClose: () => {
                setIsReminderDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            ToolId: new ToolId_4(parse(props.Tool.Id)),
        })) : empty(), delay(() => append((selectedReminder != null) ? singleton(createElement(EditReminder_OpenDialog, {
            IsOpen: selectedReminder != null,
            OnClose: () => {
                setSelectedReminder(undefined);
            },
            Reminder: unwrap(selectedReminder),
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            ToolId: new ToolId_4(parse(props.Tool.Id)),
        })) : empty(), delay(() => append((selectedDeleteReminder != null) ? singleton(createElement(DeleteReminder_OpenDialog, {
            IsOpen: selectedDeleteReminder != null,
            OnClose: () => {
                setSelectedDeleteReminder(undefined);
            },
            Reminder: unwrap(selectedDeleteReminder),
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
                props.Dispatch(new Msg(26, []));
            },
            ToolId: new ToolId_4(parse(props.Tool.Id)),
        })) : empty(), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = selectedReminderToConfirm, (matchValue_1 == null) ? (empty()) : singleton(createElement(ConfirmDialog_ConfirmReminderDialog, {
                IsOpen: selectedReminderToConfirm != null,
                OnClose: () => {
                    setSelectedReminderToConfirm(undefined);
                },
                Reminder: matchValue_1,
                SuccessCallback: (isFileUploaded) => {
                    props.Dispatch(new Msg(3, []));
                    if (isFileUploaded) {
                        props.Dispatch(new Msg(26, []));
                    }
                },
                ToolId: new ToolId_4(parse(props.Tool.Id)),
            }))), delay(() => {
                let elems_3;
                const table = (rows) => {
                    let TableRows, Options;
                    return createElement(Table, (TableRows = toArray(rows), (Options = {
                        BorderStyle: "row",
                        CSVDownload: false,
                        ConfigurableColumns: false,
                        CustomTableFilters: false,
                        DefaultSortColumn: ["data", "desc"],
                        Fullscreen: false,
                        GlobalSearch: false,
                        RowSelection: "singleRow",
                        SaveTableConfiguration: false,
                    }, {
                        ColumnDefinitions: [new ColumnDefinition$1("date", "", t("general.planned_date"), (dto) => (new CellContent(6, [dto.Date])), "dateRange", "date"), new ColumnDefinition$1("executionDate", "", t("general.execution_date"), (dto_1) => (new CellContent(6, [dto_1.ExecutionDate])), "dateRange", "date"), new ColumnDefinition$1("state", "", t("general.done"), (reminderDate) => {
                            let elems;
                            return reminderDate.IsConfirmed ? (new CellContent(1, [createElement(ColoredDot, {
                                Color: "green",
                            })])) : ((compare(reminderDate.Date, now) > 0) ? (new CellContent(1, [createElement(ColoredDot, {
                                Color: "orange",
                            })])) : (new CellContent(1, [reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])])))])));
                        }, "none", "text"), new ColumnDefinition$1("linked_inspection", "", t("inspection_result.linked_inspection"), (dto_2) => {
                            let elems_1;
                            const linkedResult = tryFind((r_1) => equals(r_1.ReminderId, dto_2.Id), props.InspectionResults);
                            if (linkedResult == null) {
                                return new CellContent(0, [""]);
                            }
                            else {
                                const result = linkedResult;
                                const color = (result.ResultStatus.tag === 1) ? "#ef4444" : "#22c55e";
                                return new CellContent(1, [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2"])], (elems_1 = [reactElement("div", {
                                    className: join(" ", ["w-3", "h-3", "rounded-full", "flex-shrink-0"]),
                                    style: {
                                        backgroundColor: color,
                                    },
                                }), reactElement("span", {
                                    className: join(" ", ["text-sm"]),
                                    children: result.InspectionTemplateName,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))]);
                            }
                        }, "none", "text"), new ColumnDefinition$1("name", "", t("general.name"), (dto_3) => (new CellContent(0, [dto_3.Title])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_4) => (new CellContent(0, [dto_4.Description])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_5) => (new CellContent(0, [dto_5.ConfirmationComment])), "none", "text"), new ColumnDefinition$1("hasDocumentLinked", "", t("document_reminder_relation.documents_link"), (dto_6) => (new CellContent(1, [createElement(Modal_OpenLinkedDocumentModalButtonModalSheet, {
                            Documents: filter((doc) => contains(DocumentId__get_unwrap(doc.Id), dto_6.DocumentIds, {
                                Equals: (x_1, y_1) => (x_1 === y_1),
                                GetHashCode: (x_1) => (stringHash(x_1) | 0),
                            }), props.Documents),
                            LinkedEntityId: new FileDialog_LinkedEntityId(0, [dto_6.Id]),
                            OnClose: () => {
                                props.Dispatch(new Msg(26, []));
                                props.Dispatch(new Msg(3, []));
                            },
                            UploadType: new FileDialog_LinkedDocumentToolType(0, [new ToolId_4(parse(props.Tool.Id))]),
                            UserData: props.UserData,
                        })])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_7) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                            EntityId: dto_7.Id,
                        })])), "none", "button")],
                        Controls: toList(delay(() => {
                            let matchValue_3, matchValue_4;
                            return append((matchValue_3 = props.Tool.State, (matchValue_3 === "active") ? append((matchValue_4 = props.UserData.Role, (matchValue_4 === "system") ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_10) => {
                                setIsReminderDialogOpen(true);
                            }, false, false, "tool-new-reminder-test-id")) : ((matchValue_4 === "toolManager") ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_10) => {
                                setIsReminderDialogOpen(true);
                            }, false, false, "tool-new-reminder-test-id")) : ((matchValue_4 === "user") ? (empty()) : singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_10) => {
                                setIsReminderDialogOpen(true);
                            }, false, false, "tool-new-reminder-test-id"))))), delay(() => append(singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                                const selectedRow = tryHead(rows_1);
                                if (selectedRow == null) {
                                }
                                else {
                                    const planning = selectedRow;
                                    const matchValue_5 = props.UserData.Role;
                                    switch (matchValue_5) {
                                        case "user": {
                                            break;
                                        }
                                        default:
                                            setSelectedReminder(planning);
                                    }
                                }
                            }, true, false, "")), delay(() => {
                                let matchValue_6;
                                return append((matchValue_6 = props.UserData.Role, (matchValue_6 === "system") ? singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                    const selectedRow_1 = tryHead(rows_2);
                                    if (selectedRow_1 != null) {
                                        setSelectedReminderToConfirm(selectedRow_1);
                                    }
                                }, false, false, "")) : ((matchValue_6 === "administrator") ? singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                    const selectedRow_1 = tryHead(rows_2);
                                    if (selectedRow_1 != null) {
                                        setSelectedReminderToConfirm(selectedRow_1);
                                    }
                                }, false, false, "")) : ((matchValue_6 === "user") ? (empty()) : singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                    const selectedRow_1 = tryHead(rows_2);
                                    if (selectedRow_1 != null) {
                                        setSelectedReminderToConfirm(selectedRow_1);
                                    }
                                }, false, false, ""))))), delay(() => {
                                    if (length(props.InspectionTemplates) > 0) {
                                        const matchValue_7 = props.UserData.Role;
                                        switch (matchValue_7) {
                                            case "user": {
                                                return empty();
                                            }
                                            default:
                                                return singleton(new TableControl$1(t("reminder_dialog.create_inspection"), Check_Circle(), (rows_3) => {
                                                    const selectedRow_3 = tryHead(rows_3);
                                                    if (selectedRow_3 != null) {
                                                        setSelectedReminderForInspection(selectedRow_3);
                                                    }
                                                }, true, false, "inspection-from-reminder-button"));
                                        }
                                    }
                                    else {
                                        return empty();
                                    }
                                }));
                            })))) : ((matchValue_3 === "lost") ? (empty()) : ((matchValue_3 === "retired") ? (empty()) : append((matchValue_4 = props.UserData.Role, (matchValue_4 === "system") ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_10) => {
                                setIsReminderDialogOpen(true);
                            }, false, false, "tool-new-reminder-test-id")) : ((matchValue_4 === "toolManager") ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_10) => {
                                setIsReminderDialogOpen(true);
                            }, false, false, "tool-new-reminder-test-id")) : ((matchValue_4 === "user") ? (empty()) : singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_10) => {
                                setIsReminderDialogOpen(true);
                            }, false, false, "tool-new-reminder-test-id"))))), delay(() => append(singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                                const selectedRow = tryHead(rows_1);
                                if (selectedRow == null) {
                                }
                                else {
                                    const planning = selectedRow;
                                    const matchValue_5 = props.UserData.Role;
                                    switch (matchValue_5) {
                                        case "user": {
                                            break;
                                        }
                                        default:
                                            setSelectedReminder(planning);
                                    }
                                }
                            }, true, false, "")), delay(() => {
                                let matchValue_6;
                                return append((matchValue_6 = props.UserData.Role, (matchValue_6 === "system") ? singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                    const selectedRow_1 = tryHead(rows_2);
                                    if (selectedRow_1 != null) {
                                        setSelectedReminderToConfirm(selectedRow_1);
                                    }
                                }, false, false, "")) : ((matchValue_6 === "administrator") ? singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                    const selectedRow_1 = tryHead(rows_2);
                                    if (selectedRow_1 != null) {
                                        setSelectedReminderToConfirm(selectedRow_1);
                                    }
                                }, false, false, "")) : ((matchValue_6 === "user") ? (empty()) : singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                    const selectedRow_1 = tryHead(rows_2);
                                    if (selectedRow_1 != null) {
                                        setSelectedReminderToConfirm(selectedRow_1);
                                    }
                                }, false, false, ""))))), delay(() => {
                                    if (length(props.InspectionTemplates) > 0) {
                                        const matchValue_7 = props.UserData.Role;
                                        switch (matchValue_7) {
                                            case "user": {
                                                return empty();
                                            }
                                            default:
                                                return singleton(new TableControl$1(t("reminder_dialog.create_inspection"), Check_Circle(), (rows_3) => {
                                                    const selectedRow_3 = tryHead(rows_3);
                                                    if (selectedRow_3 != null) {
                                                        setSelectedReminderForInspection(selectedRow_3);
                                                    }
                                                }, true, false, "inspection-from-reminder-button"));
                                        }
                                    }
                                    else {
                                        return empty();
                                    }
                                }));
                            }))))))), delay(() => singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_4) => {
                                const selectedRow_5 = tryHead(rows_4);
                                if (selectedRow_5 == null) {
                                }
                                else {
                                    const planning_1 = selectedRow_5;
                                    const matchValue_8 = props.UserData.Role;
                                    switch (matchValue_8) {
                                        case "user": {
                                            break;
                                        }
                                        default:
                                            setSelectedDeleteReminder(planning_1);
                                    }
                                }
                            }, true, false, ""))));
                        })),
                        Options: Options,
                        TableKey: "not-defined-table",
                        TableRows: TableRows,
                    })));
                };
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_3 = toList(delay(() => append(singleton(table((length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                    let elems_2;
                    return (length(reminders) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems_2 = [createElement(Button, {
                        ComponentState: "enabled",
                        Label: t("general.show_more_data"),
                        OnClick: () => {
                            setIsModalOpen(true);
                        },
                        TestId: "tool-reminders-showmoredata-button",
                        Variant: "blueButton",
                    }), createElement(ModalSheet, {
                        CloseButtonTestId: "",
                        Content: table(reminders),
                        Controls: empty_1(),
                        IsModalOpen: patternInput_1[0],
                        OnClose: () => {
                            setIsModalOpen(false);
                        },
                        Title: t("general.appointments"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty();
                })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
            }));
        }))))))));
    }));
    return react.createElement(react.Fragment, {}, ...xs_6);
}

function HistorySection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setAssignmentProtocolParams = patternInput_2[1];
    const table = (rows) => {
        let TableRows;
        return createElement(Table, (TableRows = toArray(rows), {
            ColumnDefinitions: [new ColumnDefinition$1("timestamp", "", t("general.date"), (dto) => (new CellContent(7, [dto.Timestamp])), "none", "dateTime"), new ColumnDefinition$1("eventType", "", t("general.event"), (dto_1) => (new CellContent(0, [t(Helper_historyTypeToTranslationString(dto_1.EventType))])), "select", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_2) => {
                const matchValue = dto_2.Event;
                return (matchValue == null) ? (new CellContent(0, [t(dto_2.Comment)])) : (new CellContent(0, [Helper_displayHistoryComment(t(matchValue), dto_2.Comment)]));
            }, "none", "text"), new ColumnDefinition$1("receiver", "", t("general.receiver"), (dto_3) => (new CellContent(0, [defaultArg(map_1((receiverInformation) => receiverInformation.Name, dto_3.ReceiverInformation), "")])), "select", "text"), new ColumnDefinition$1("sender", "", t("general.sender"), (dto_4) => (new CellContent(0, [dto_4.SenderInformation.Name])), "select", "text"), new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (dto_5) => {
                let matchValue_1;
                return new CellContent(4, [(matchValue_1 = dto_5.ReceiverInformation, (matchValue_1 != null) ? defaultArg(map_1((x) => x, matchValue_1.SignatureUrl), "") : "")]);
            }, "none", "image"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_6) => (new CellContent(0, [defaultArg(map_1((storage) => storage.Name, dto_6.StorageInformation), "")])), "none", "text"), new ColumnDefinition$1("action", "", "", (dto_7) => {
                const matchValue_2 = dto_7.EventType;
                switch (matchValue_2) {
                    case "procedureCompleted":
                    case "procedureCancelled": {
                        const matchValue_4 = dto_7.ProcedureId;
                        if (matchValue_4 == null) {
                            return new CellContent(0, [""]);
                        }
                        else {
                            const procedureId = matchValue_4;
                            return new CellContent(2, [t("procedure.view_results"), () => {
                                RouterModule_nav(ofArray(["procedures", procedureId, "results"]), 1, 1);
                            }]);
                        }
                    }
                    case "inspectionResultCreated": {
                        const matchValue_5 = dto_7.InspectionResultId;
                        if (matchValue_5 == null) {
                            return new CellContent(0, [""]);
                        }
                        else {
                            const inspectionResultId = matchValue_5;
                            return new CellContent(1, [createElement(Modal_OpenLinkedDocumentModalButtonModalSheet, {
                                Documents: filter((doc) => defaultArg(map_1((info) => (info.InspectionResultId === inspectionResultId), doc.LinkedInspectionResultInformation), false), props.Documents),
                                LinkedEntityId: new FileDialog_LinkedEntityId(1, [inspectionResultId]),
                                OnClose: () => {
                                    props.Dispatch(new Msg(26, []));
                                    props.Dispatch(new Msg(40, []));
                                },
                                UploadType: new FileDialog_LinkedDocumentToolType(0, [new ToolId_4(parse(props.ToolId))]),
                                UserData: props.UserData,
                            })]);
                        }
                    }
                    case "problemReported":
                    case "updatedStock":
                    case "updatedStorage":
                    case "inMaintenance":
                    case "retired":
                    case "activate":
                    case "lost":
                    case "addedToSet":
                    case "removedFromSet":
                    case "changeInformation":
                    case "releaseDate":
                    case "deleteReleaseDate":
                    case "stocktakingStorageCorrectionBooking":
                    case "stocktakingReceiverCorrectionBooking":
                    case "stocktakingCorrectionBooking":
                        return new CellContent(0, [""]);
                    default:
                        return new CellContent(2, [t("assignment_protocol.open_assignment_protocol"), () => {
                            let AssignmentType, ReceiverName, StorageName;
                            setAssignmentProtocolParams((AssignmentType = t(Helper_historyTypeToTranslationString(dto_7.EventType)), (ReceiverName = defaultArg(map_1((_arg_1) => _arg_1.Name, dto_7.ReceiverInformation), ""), (StorageName = map_1((_arg_2) => _arg_2.Name, dto_7.StorageInformation), new AssignmentProtocolParams(AssignmentType, props.ToolName, props.InventoryNumber, dto_7.SenderInformation.Name, ReceiverName, props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.QrCodeIds ? (isEmpty(props.QrCodeIds) ? "" : reduce((list_1, code) => concat(list_1, ", ", ...code), props.QrCodeIds)) : undefined, StorageName, dto_7.Comment, undefined, flatten(map_1((_arg_3) => _arg_3.SignatureUrl, dto_7.ReceiverInformation)), dto_7.Timestamp, (props.BusinessUnitImageUrl == null) ? props.CustomerConfiguration.ProtocolConfiguration.ImageUrl : props.BusinessUnitImageUrl, dto_7.SenderImageUrls, dto_7.ReceiverImageUrls)))));
                        }]);
                }
            }, "none", "text")],
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: true,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["timestamp", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(AssignmentProtocolDialog, {
        AssignmentProtocolParams: unwrap(patternInput_2[0]),
        OnClose: () => {
            setAssignmentProtocolParams(undefined);
        },
    })), delay(() => append(singleton(table((length(props.HistoryRows) > 5) ? take(5, props.HistoryRows) : props.HistoryRows)), delay(() => {
        let elems;
        return (length(props.HistoryRows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: table(props.HistoryRows),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: t("history.title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ProblemReportSection(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsProblemReportOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedDeleteProblemReport = patternInput_3[1];
    const selectedDeleteProblemReport = patternInput_3[0];
    const table = (rows) => {
        let TableRows, ColumnDefinitions, Options, matchValue_1;
        return createElement(Table, (TableRows = toArray(rows), (ColumnDefinitions = [new ColumnDefinition$1("timestamp", "", t("tool.problem_report_registered_on"), (dto) => (new CellContent(7, [dto.Timestamp])), "none", "dateTime"), new ColumnDefinition$1("sender", "", t("tool.problem_report_reported_by"), (dto_1) => (new CellContent(0, [dto_1.Sender])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.message"), (dto_2) => (new CellContent(0, [dto_2.Message])), "none", "text"), new ColumnDefinition$1("solver", "", t("tool.problem_report_solved_by"), (dto_3) => (new CellContent(0, [dto_3.Solver])), "none", "text"), new ColumnDefinition$1("state", "", t("general.state"), (dto_4) => (new CellContent(1, [(dto_4.State.tag === 0) ? createElement(ColoredDot, {
            Color: "orange",
        }) : createElement(ColoredDot, {
            Color: "green",
        })])), "none", "text")], (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["", "desc"],
            Fullscreen: false,
            GlobalSearch: false,
            OnRowClick: unwrap((matchValue_1 = props.UserData.Role, (matchValue_1 === "system") ? (new OnTableRowClick$1(0, [(problemReport) => {
                props.Dispatch(new Msg(7, [tryFind((pr) => equals(problemReport.Id, pr.Id), props.ProblemReports)]));
            }])) : ((matchValue_1 === "toolManager") ? (new OnTableRowClick$1(0, [(problemReport) => {
                props.Dispatch(new Msg(7, [tryFind((pr) => equals(problemReport.Id, pr.Id), props.ProblemReports)]));
            }])) : ((matchValue_1 === "user") ? undefined : (new OnTableRowClick$1(0, [(problemReport) => {
                props.Dispatch(new Msg(7, [tryFind((pr) => equals(problemReport.Id, pr.Id), props.ProblemReports)]));
            }])))))),
            RowSelection: "singleRow",
            SaveTableConfiguration: false,
        }, {
            ColumnDefinitions: ColumnDefinitions,
            Controls: toList(delay(() => {
                let matchValue_2;
                return append((matchValue_2 = props.Tool.State, (matchValue_2 === "active") ? singleton(new TableControl$1(t("dialog.problem_report.btn_title"), Shipment_Warning(), (_arg) => {
                    setIsProblemReportOpen(true);
                }, false, false, "")) : ((matchValue_2 === "lost") ? (empty()) : ((matchValue_2 === "retired") ? (empty()) : singleton(new TableControl$1(t("dialog.problem_report.btn_title"), Shipment_Warning(), (_arg) => {
                    setIsProblemReportOpen(true);
                }, false, false, ""))))), delay(() => {
                    const matchValue_3 = props.UserData.Role;
                    switch (matchValue_3) {
                        case "toolManager":
                        case "user": {
                            return empty();
                        }
                        default:
                            return singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_1) => {
                                const selectedRow = tryHead(rows_1);
                                if (selectedRow == null) {
                                }
                                else {
                                    setSelectedDeleteProblemReport(selectedRow);
                                }
                            }, true, false, ""));
                    }
                }));
            })),
            Options: Options,
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }))));
    };
    const children = toList(delay(() => append(singleton(createElement(ToolCreateProblemReportDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsProblemReportOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(3, []));
        },
        ToolId: new ToolId_4(parse(props.Tool.Id)),
        UserId: props.UserId,
    })), delay(() => {
        let matchValue_4;
        return append((matchValue_4 = props.SelectedProblemReport, (matchValue_4 == null) ? (empty()) : singleton(createElement(ProblemReportDialog, {
            IsOpen: props.SelectedProblemReport != null,
            OnClose: () => {
                props.Dispatch(new Msg(7, [undefined]));
            },
            ProblemReportId: matchValue_4.Id,
            SuccessCallback: () => {
                props.Dispatch(new Msg(29, []));
            },
            ToolId: new ToolId_4(parse(props.Tool.Id)),
            UserData: props.UserData,
            UserId: props.UserId,
        }))), delay(() => {
            let Title;
            return append(singleton(createElement(ConfirmationDialog, (Title = t("tool.delete_problem_report"), {
                Description: t("tool.delete_problem_report_description"),
                IsOpen: selectedDeleteProblemReport != null,
                OnClose: () => {
                    setSelectedDeleteProblemReport(undefined);
                },
                OnConfirm: () => {
                    if (selectedDeleteProblemReport == null) {
                    }
                    else {
                        props.Dispatch(new Msg(6, [selectedDeleteProblemReport]));
                    }
                    setSelectedDeleteProblemReport(undefined);
                },
                Title: Title,
            }))), delay(() => {
                let elems_1;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(table((length(props.ProblemReports) > 5) ? take(5, props.ProblemReports) : props.ProblemReports)), delay(() => {
                    let elems;
                    return (length(props.ProblemReports) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                        ComponentState: "enabled",
                        Label: t("general.show_more_data"),
                        OnClick: () => {
                            setIsModalOpen(true);
                        },
                        TestId: "tool-selectcard-tooldetail-showmoredata-button",
                        Variant: "blueButton",
                    }), createElement(ModalSheet, {
                        CloseButtonTestId: "",
                        Content: table(props.ProblemReports),
                        Controls: empty_1(),
                        IsModalOpen: patternInput_1[0],
                        OnClose: () => {
                            setIsModalOpen(false);
                        },
                        Title: t("tool.reported_problems"),
                        ZIndex: 19,
                    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
                })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }));
        }));
    }))));
    return reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function SetInfo(props) {
    let elems_6, elems_1, elems, elems_5, elems_2, arg_1, elems_3, elems_4;
    const patternInput = useTranslation();
    const t = patternInput[0];
    return reactElement("div", createObj(ofArray([["data-test-id", concat("set-info-", ...SetId__get_unwrap(props.SetId))], ["className", join(" ", ["bg-[#EFF6FF]", "min-w-85", "text-sm", "flex", "flex-row", "p-3.5", "rounded"])], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-3.5", "mt-0.5", "h-3.5", "w-3.5", "text-icon-blue", "stroke-2"])], (elems = [Information_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2.5"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["text-[#284CB1]", "font-medium"])], (elems_2 = [(arg_1 = {
        name: props.Name,
    }, patternInput[1].t("tool.assigned_to_set", arg_1))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["text-[#315CD5]", "flex", "flex-col", "mb-5.5", "leading-5", "font-normal", "text-sm", "whitespace-pre"])], (elems_3 = [reactElement("div", {
        children: [t("tool.assigned_to_set_details")],
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["text-[#284CB1]", "font-medium"])], (elems_4 = [reactElement("a", {
        href: RouterModule_encodeParts(ofArray(["sets", SetId__get_unwrap(props.SetId)]), 1),
        children: t("tool.assigned_to_set_link"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function ToolDetailsArea(props) {
    let elems_4;
    const tool = props.Tool;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems_4 = toList(delay(() => {
        let matchValue, set$, elems;
        return append((matchValue = tool.AssignedSet, (matchValue == null) ? singleton(createElement(ToolDetailsActions, {
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HasManualHooks: props.HasManualHooks,
            IsVisibleForUser: props.IsVisibleForUser,
            SetCurrentSelectedLink: props.SetCurrentSelectedLink,
            Storages: props.Storages,
            Tool: props.Tool,
            UserData: props.UserData,
            UserId: props.UserData.UserId,
        })) : ((set$ = matchValue, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-8"])], (elems = [createElement(SetInfo, {
            Name: set$.DisplayName,
            SetId: set$.SetId,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))))))), delay(() => {
            let matchValue_1;
            return append(singleton(createElement(NotificationArea, {
                IsCurrentUserStorageResponsible: (matchValue_1 = props.UserData.Role, (matchValue_1 === "system") ? true : ((matchValue_1 === "toolManager") ? contains(props.UserData.UserId, props.Tool.StorageInformation.AssignedUserIds, {
                    Equals: (x, y) => (x === y),
                    GetHashCode: (x) => (stringHash(x) | 0),
                }) : ((matchValue_1 === "user") ? contains(props.UserData.UserId, props.Tool.StorageInformation.AssignedUserIds, {
                    Equals: (x, y) => (x === y),
                    GetHashCode: (x) => (stringHash(x) | 0),
                }) : true))),
                NotificationToolType: new NotificationToolType_1(0, []),
                Notifications: props.Notifications,
                OnUpdate: () => {
                    props.Dispatch(new Msg(3, []));
                },
                UserData: props.UserData,
            })), delay(() => {
                let elems_2, elems_1, Images, matchValue_2;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "mb-8"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-16"])], (elems_1 = [createElement(MultipleImageWidget, (Images = map((image) => ({
                    ImageUrl: image.ImageUrl,
                    Position: image.Position,
                }), tool.ToolImages), {
                    CanEditImage: (matchValue_2 = props.UserData.Role, (matchValue_2 === "system") ? true : ((matchValue_2 === "toolManager") ? true : (!(matchValue_2 === "user")))),
                    ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
                    FormImages: props.ToolImages,
                    Images: Images,
                    OnImagesChanged: (arg) => {
                        props.Dispatch(new Msg(2, [arg]));
                    },
                    OnSave: () => {
                        props.Dispatch(new Msg(19, []));
                    },
                }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(ToolShortDetails, {
                    AccountSettings: props.AccountSettings,
                    CurrentUser: props.CurrentUser,
                    CustomerConfiguration: props.CustomerConfiguration,
                    Dispatch: props.Dispatch,
                    QuickOverviewDialog: props.QuickOverviewDialog,
                    Storages: props.Storages,
                    Tool: tool,
                    UserConfiguration: props.UserConfiguration,
                    UserData: props.UserData,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let elems_3;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "gap-5", "mt-3"])], (elems_3 = toList(delay(() => append(props.AccountSettings.InspectionsEnabled ? singleton(createElement(InspectionStatusBox, {
                        InspectionResults: props.InspectionResults,
                        InspectionTemplates: props.InspectionTemplates,
                        SetCurrentSelectedLink: props.SetCurrentSelectedLink,
                        ToolCategoryIds: map((_arg_2) => _arg_2.CategoryId, tool.Categories),
                    })) : empty(), delay(() => append(singleton(createElement(PlanningBox, {
                        SetCurrentSelectedLink: props.SetCurrentSelectedLink,
                        Tool: tool,
                    })), delay(() => singleton(createElement(NotificationsBox, {
                        ProblemReports: props.ProblemReports,
                        SetCurrentSelectedLink: props.SetCurrentSelectedLink,
                    })))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function NoticeSection(props) {
    let elems;
    const messages = map((n) => (new Message_1(new NoticeId(parse(n.Id)), n.Description, undefined, n.CreatedAt, n.CreatorInformation.Name, n.CreatorInformation.Id, n.IsVisibleForUser)), props.Tool.Notices);
    const patternInput = reactApi.useState(true);
    const setIsVisibleForUser = patternInput[1];
    const isVisibleForUser = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setSelectedNoticeIdToDelete = patternInput_1[1];
    const selectedNoticeIdToDelete = patternInput_1[0];
    return reactElement("div", createObj(singleton_1((elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = selectedNoticeIdToDelete, (matchValue == null) ? (empty()) : singleton(createElement(OpenNoticeDeleteDialog, {
            IsOpen: selectedNoticeIdToDelete != null,
            NoticeId: matchValue,
            OnClose: () => {
                setSelectedNoticeIdToDelete(undefined);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(3, []));
            },
            ToolId: new ToolId_4(parse(props.Tool.Id)),
        }))), delay(() => singleton(createElement(ChatWidget, {
            CanUploadImage: false,
            CustomerConfiguration: props.CustomerConfiguration,
            IsSubmitting: false,
            MaxContentHeigth: "max-h-96",
            Messages: messages,
            OnDeleteClicked: (message_1) => {
                setSelectedNoticeIdToDelete(message_1.Id);
            },
            OnEditClicked: (message) => {
                props.Dispatch(new Msg(17, [message]));
            },
            OnSubmit: (msg, _arg_2) => {
                props.Dispatch(new Msg(15, [msg, isVisibleForUser]));
                setIsVisibleForUser(true);
            },
            UserData: props.UserData,
            UserId: props.UserId,
            UserVisibility: {
                IsVisibleForUserChecked: isVisibleForUser,
                OnVisibleForUserChecked: setIsVisibleForUser,
            },
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

class CreateInspectionResultElmish_CreateMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSelectedTemplate", "SetInspectionDate", "SetSelectedResult", "SetInspectionComment", "AddFiles", "RemoveFile", "SetFileName", "SetFileDescription", "SetIsVisibleForUserRole", "SubmitCreate", "InspectionResultCreated", "FileUploaded", "FetchError"];
    }
}

function CreateInspectionResultElmish_CreateMsg_$reflection() {
    return union_type("Tools.Tool.Details.View.CreateInspectionResultElmish.CreateMsg", [], CreateInspectionResultElmish_CreateMsg, () => [[["Item", option_type(anonRecord_type(["label", string_type], ["value", class_type("System.Guid")]))]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", option_type(anonRecord_type(["color", string_type], ["label", string_type], ["value", string_type]))]], [["Item", string_type]], [["Item", list_type(class_type("Browser.Types.File", undefined))]], [["Item", int32_type]], [["Item1", int32_type], ["Item2", string_type]], [["Item1", int32_type], ["Item2", string_type]], [["Item", bool_type]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", PostResponse$1_$reflection(EmptyResponse_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class CreateInspectionResultElmish_CreateState extends Record {
    constructor(ToolId, FormState, SuccessCallback, OnClose, InspectionTemplates, ToolCategoryIds, SelectedTemplate, InspectionDate, SelectedResult, InspectionComment, FileEntries, PendingUploads, IsVisibleForUserRole, InspectionResultId) {
        super();
        this.ToolId = ToolId;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.InspectionTemplates = InspectionTemplates;
        this.ToolCategoryIds = ToolCategoryIds;
        this.SelectedTemplate = SelectedTemplate;
        this.InspectionDate = InspectionDate;
        this.SelectedResult = SelectedResult;
        this.InspectionComment = InspectionComment;
        this.FileEntries = FileEntries;
        this.PendingUploads = PendingUploads;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
        this.InspectionResultId = InspectionResultId;
    }
}

function CreateInspectionResultElmish_CreateState_$reflection() {
    return record_type("Tools.Tool.Details.View.CreateInspectionResultElmish.CreateState", [], CreateInspectionResultElmish_CreateState, () => [["ToolId", string_type], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["InspectionTemplates", list_type(DTO_InspectionTemplateDetailDto_$reflection())], ["ToolCategoryIds", list_type(string_type)], ["SelectedTemplate", option_type(anonRecord_type(["label", string_type], ["value", class_type("System.Guid")]))], ["InspectionDate", option_type(class_type("System.DateTime"))], ["SelectedResult", option_type(anonRecord_type(["color", string_type], ["label", string_type], ["value", string_type]))], ["InspectionComment", string_type], ["FileEntries", list_type(FileEntry_$reflection())], ["PendingUploads", list_type(FileEntry_$reflection())], ["IsVisibleForUserRole", bool_type], ["InspectionResultId", option_type(string_type)]]);
}

function CreateInspectionResultElmish_createInspectionResultCmd(toolId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/inspection-results/tools/", ...toolId), toString_1(0, Auto_generateBoxedEncoder_437914C6(DTO_WriteInspectionResultDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new CreateInspectionResultElmish_CreateMsg(10, [Item])), (Item_1) => (new CreateInspectionResultElmish_CreateMsg(12, [Item_1])));
}

function CreateInspectionResultElmish_uploadFileCmd(toolId, inspectionResultId, isVisibleForUserRole, entry) {
    const formData = new FormData();
    formData.append(entry.File.name, entry.File);
    formData.append("Name", entry.Name);
    formData.append("Description", entry.Description);
    formData.append("IsVisibleForUserRole", toString_2(isVisibleForUserRole));
    formData.append("InspectionResultId", inspectionResultId);
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(tupledArg[0]), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), undefined, (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
    })))), [concat("/api/tools/", toolId, ..."/files"), formData], (Item) => (new CreateInspectionResultElmish_CreateMsg(11, [Item])), (Item_1) => (new CreateInspectionResultElmish_CreateMsg(12, [Item_1])));
}

function CreateInspectionResultElmish_uploadNextOrFinish(state) {
    const matchValue = state.PendingUploads;
    const matchValue_1 = state.InspectionResultId;
    let matchResult, head, irId, tail;
    if (!isEmpty(matchValue)) {
        if (matchValue_1 != null) {
            matchResult = 0;
            head = head_1(matchValue);
            irId = matchValue_1;
            tail = tail_1(matchValue);
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.FileEntries, tail, state.IsVisibleForUserRole, state.InspectionResultId), CreateInspectionResultElmish_uploadFileCmd(state.ToolId, irId, state.IsVisibleForUserRole, head)];
        default:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.FileEntries, empty_1(), state.IsVisibleForUserRole, undefined), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                state.SuccessCallback();
            }), Cmd_ofEffect((_arg_1) => {
                state.OnClose();
            }), Cmd_successToast("inspection_result.created_successfully")]))];
    }
}

function CreateInspectionResultElmish_initCreate(toolId, successCallback, onClose, inspectionTemplates, toolCategoryIds) {
    return [new CreateInspectionResultElmish_CreateState(toolId, FormState_get_empty(), successCallback, onClose, inspectionTemplates, toolCategoryIds, undefined, now_1(), undefined, "", empty_1(), empty_1(), false, undefined), Cmd_none()];
}

function CreateInspectionResultElmish_updateFileEntry(index, updater, entries) {
    return map((tupledArg) => {
        const e = tupledArg[1];
        if (tupledArg[0] === index) {
            return updater(e);
        }
        else {
            return e;
        }
    }, indexed(entries));
}

function CreateInspectionResultElmish_updateCreate(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, msg.fields[0], state.SelectedResult, state.InspectionComment, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 2:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, msg.fields[0], state.InspectionComment, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 3:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, msg.fields[0], state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 4:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, append_1(state.FileEntries, map((f) => (new FileEntry(f, "", "")), msg.fields[0])), state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 5:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, choose((tupledArg) => {
                if (tupledArg[0] !== msg.fields[0]) {
                    return tupledArg[1];
                }
                else {
                    return undefined;
                }
            }, indexed(state.FileEntries)), state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 6:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, CreateInspectionResultElmish_updateFileEntry(msg.fields[0], (e_1) => (new FileEntry(e_1.File, msg.fields[1], e_1.Description)), state.FileEntries), state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 7:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, CreateInspectionResultElmish_updateFileEntry(msg.fields[0], (e_2) => (new FileEntry(e_2.File, e_2.Name, msg.fields[1])), state.FileEntries), state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
        case 8:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.FileEntries, state.PendingUploads, msg.fields[0], state.InspectionResultId), Cmd_none()];
        case 9: {
            const matchValue = state.SelectedTemplate;
            const matchValue_1 = state.InspectionDate;
            const matchValue_2 = state.SelectedResult;
            let matchResult, date, result, tmpl;
            if (matchValue != null) {
                if (matchValue_1 != null) {
                    if (matchValue_2 != null) {
                        matchResult = 0;
                        date = matchValue_1;
                        result = matchValue_2;
                        tmpl = matchValue;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const dto = new DTO_WriteInspectionResultDto(tmpl.value, date, result.value, (result.color === "#22c55e") ? (new InspectionResultStatus(0, [])) : (new InspectionResultStatus(1, [])), state.InspectionComment, empty_1(), undefined);
                    return [new CreateInspectionResultElmish_CreateState(state.ToolId, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), CreateInspectionResultElmish_createInspectionResultCmd(state.ToolId, dto)];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 10: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new CreateInspectionResultElmish_CreateState(state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_errorToast("validation.toast")];
            }
            else {
                return CreateInspectionResultElmish_uploadNextOrFinish(new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.FileEntries, state.FileEntries, state.IsVisibleForUserRole, response.fields[0]));
            }
        }
        case 11:
            return CreateInspectionResultElmish_uploadNextOrFinish(state);
        case 12:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, state.SelectedTemplate, state.InspectionDate, state.SelectedResult, state.InspectionComment, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_errorToast("validation.toast")];
        default:
            return [new CreateInspectionResultElmish_CreateState(state.ToolId, state.FormState, state.SuccessCallback, state.OnClose, state.InspectionTemplates, state.ToolCategoryIds, msg.fields[0], state.InspectionDate, undefined, state.InspectionComment, state.FileEntries, state.PendingUploads, state.IsVisibleForUserRole, state.InspectionResultId), Cmd_none()];
    }
}

function CreateInspectionResultDialog(props) {
    let Title, elems_13;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => CreateInspectionResultElmish_initCreate(props.ToolId, props.SuccessCallback, props.OnClose, props.InspectionTemplates, props.ToolCategoryIds), CreateInspectionResultElmish_updateCreate, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const formState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const availableTemplates = filter((tmpl) => exists((catId) => contains(catId, state_1.ToolCategoryIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), tmpl.CategoryIds), state_1.InspectionTemplates);
    const templateOptions = map((tmpl_1) => ({
        label: tmpl_1.Name,
        value: tmpl_1.Id,
    }), availableTemplates);
    const resultOptions = defaultArg(map_1((t_2) => append_1(map((r) => ({
        color: "#22c55e",
        label: r,
        value: r,
    }), t_2.SuccessfulResults), map((r_1) => ({
        color: "#ef4444",
        label: r_1,
        value: r_1,
    }), t_2.FailedResults)), bind((opt) => tryFind((t_1) => (t_1.Id === opt.value), availableTemplates), state_1.SelectedTemplate)), empty_1());
    const canSubmit = (((state_1.SelectedTemplate != null) && (state_1.InspectionDate != null)) && (state_1.SelectedResult != null)) && !state_1.FormState.IsLoading;
    const patternInput_2 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let files;
            const matchValue = draggedFile.files;
            let matchResult, files_1;
            if (matchValue != null) {
                if ((files = matchValue, files.length > 0)) {
                    matchResult = 0;
                    files_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    dispatch(new CreateInspectionResultElmish_CreateMsg(4, [ofArray(files_1)]));
                    break;
                }
                case 1: {
                    break;
                }
            }
        },
    });
    const dropData = patternInput_2[0];
    return createElement(Dialog, (Title = t("inspection_result.create"), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_13 = toList(delay(() => append(singleton(createElement(Select, {
            ComponentState: formState,
            IsClearable: true,
            Label: t("inspection_result.template"),
            NoOptionsMessage: "general.no_options",
            OnChange: (opt_1) => {
                dispatch(new CreateInspectionResultElmish_CreateMsg(0, [opt_1]));
            },
            Options: templateOptions,
            PlaceholderKey: "inspection_result.template_placeholder",
            TestId: "inspection-result-template-select",
            Value: unwrap(state_1.SelectedTemplate),
        })), delay(() => append(singleton(createElement(DatePicker, {
            ComponentState: formState,
            IsClearable: false,
            Label: t("inspection_result.date"),
            OnChange: (newDate) => {
                dispatch(new CreateInspectionResultElmish_CreateMsg(1, [newDate]));
            },
            TestId: "inspection-result-date-picker",
            Value: unwrap(state_1.InspectionDate),
        })), delay(() => append((length(resultOptions) > 0) ? singleton(createElement(SelectWithColor, {
            ComponentState: formState,
            IsClearable: true,
            Label: t("inspection_result.result"),
            NoOptionsMessage: "general.no_options",
            OnChange: (opt_2) => {
                dispatch(new CreateInspectionResultElmish_CreateMsg(2, [opt_2]));
            },
            Options: resultOptions,
            PlaceholderKey: "inspection_result.result_placeholder",
            TestId: "inspection-result-result-select",
            Value: unwrap(state_1.SelectedResult),
        })) : empty(), delay(() => append(singleton(createElement(TextArea, {
            ComponentState: formState,
            Label: t("inspection_result.comment"),
            OnChange: (value_3) => {
                dispatch(new CreateInspectionResultElmish_CreateMsg(3, [value_3]));
            },
            TestId: "inspection-result-comment",
            Value: state_1.InspectionComment,
        })), delay(() => {
            let elems_12;
            return singleton(reactElement("div", createObj(singleton_1((elems_12 = toList(delay(() => append(singleton(reactElement("label", {
                className: join(" ", ["text-sm", "font-bold", "mb-2", "block"]),
                children: t("inspection_result.document_upload"),
            })), delay(() => {
                let elems_1, elems, Label_4;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("items-center"), delay(() => append(singleton("mt-4"), delay(() => append(singleton("mb-4"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("border"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => ((dropData.canDrop && dropData.isOver) ? singleton("bg-background") : empty()))))))))))))))))))))))))], ["ref", patternInput_2[1]], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "mb-4"])], (elems = [createElement(TextButton, (Label_4 = t("file_upload.select_file"), {
                    ComponentState: formState,
                    Icon: Upload_File(),
                    Label: Label_4,
                    OnClick: () => {
                        const element = document.getElementById("inspection-file-upload");
                        element.click();
                    },
                    TestId: "inspection-file-upload-btn",
                    Variant: "blueButton",
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let elems_2;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems_2 = [reactElement("input", {
                        id: "inspection-file-upload",
                        className: join(" ", ["hidden"]),
                        type: "file",
                        multiple: true,
                        onChange: (ev) => {
                            const fileList = ev.target.files;
                            if (!(fileList == null)) {
                                dispatch(new CreateInspectionResultElmish_CreateMsg(4, [toList(delay(() => map_2((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1))))]));
                            }
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                        let elems_10;
                        return append(!isEmpty(state_1.FileEntries) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "mt-2"])], (elems_10 = toList(delay(() => map((tupledArg) => {
                            let elems_9, elems_7, elems_4, elems_3, elems_6, elems_5, elems_8;
                            const index = tupledArg[0] | 0;
                            const entry = tupledArg[1];
                            return reactElement("div", createObj(ofArray([["className", join(" ", ["rounded-md", "border", "border-border", "p-3"])], (elems_9 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "mb-2"])], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "min-w-0"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5", "flex-shrink-0"])], (elems_3 = [New_File()], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("span", {
                                className: join(" ", ["text-sm", "truncate", "font-medium"]),
                                children: entry.File.name,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("button", createObj(ofArray([["className", join(" ", ["text-gray-400", "hover:text-red-500", "flex-shrink-0", "ml-2", "cursor-pointer"])], ["onClick", (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                dispatch(new CreateInspectionResultElmish_CreateMsg(5, [index]));
                            }], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-5", "w-5"])], (elems_5 = [Delete_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_8 = [createElement(Input, {
                                ComponentState: formState,
                                Label: t("general.name"),
                                OnChange: (v) => {
                                    dispatch(new CreateInspectionResultElmish_CreateMsg(6, [index, v]));
                                },
                                TestId: `inspection-doc-name-${index}`,
                                Value: entry.Name,
                            }), createElement(Input, {
                                ComponentState: formState,
                                Label: t("general.description"),
                                OnChange: (v_1) => {
                                    dispatch(new CreateInspectionResultElmish_CreateMsg(7, [index, v_1]));
                                },
                                TestId: `inspection-doc-description-${index}`,
                                Value: entry.Description,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
                        }, indexed(state_1.FileEntries)))), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty(), delay(() => {
                            let elems_11;
                            return !isEmpty(state_1.FileEntries) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2", "mt-2"])], (elems_11 = [Checkbox({
                                ComponentState: formState,
                                IsChecked: state_1.IsVisibleForUserRole,
                                Label: t("tool.document_visible_for_user_role"),
                                OnCheck: (value_43) => {
                                    dispatch(new CreateInspectionResultElmish_CreateMsg(8, [value_43]));
                                },
                                TestId: "inspection-doc-visible-for-user-role",
                            }), createElement(InformationAlert, {
                                Label: t("tool.document_visible_for_user_role_upload_info"),
                            })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))) : empty();
                        }));
                    }));
                }));
            })))), ["children", reactApi.Children.toArray(Array.from(elems_12))])))));
        })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_13))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "cancel-inspection-result",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: canSubmit ? "enabled" : "disabled",
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new CreateInspectionResultElmish_CreateMsg(9, []));
            },
            TestId: "save-inspection-result",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

function EditInspectionResultDialog(props) {
    let Title, Title_1, elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setInspectionDate = patternInput_1[1];
    const inspectionDate = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setSelectedResultOption = patternInput_2[1];
    const selectedResultOption = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const setComment = patternInput_3[1];
    const comment = patternInput_3[0];
    const patternInput_4 = reactApi.useState(false);
    const setIsDeleteConfirmOpen = patternInput_4[1];
    const dependencies = [props.IsOpen];
    reactApi.useEffect(() => {
        if (props.IsOpen) {
            const resultColor = (props.InspectionResult.ResultStatus.tag === 1) ? "#ef4444" : "#22c55e";
            setInspectionDate(props.InspectionResult.InspectionDate);
            setSelectedResultOption({
                color: resultColor,
                label: props.InspectionResult.Result,
                value: props.InspectionResult.Result,
            });
            setComment(props.InspectionResult.Comment);
            setIsDeleteConfirmOpen(false);
        }
    }, dependencies);
    const resultOptions = defaultArg(map_1((t_2) => append_1(map((r) => ({
        color: "#22c55e",
        label: r,
        value: r,
    }), t_2.SuccessfulResults), map((r_1) => ({
        color: "#ef4444",
        label: r_1,
        value: r_1,
    }), t_2.FailedResults)), tryFind((t_1) => (t_1.Id === props.InspectionResult.InspectionTemplateId), props.InspectionTemplates)), empty_1());
    if (patternInput_4[0]) {
        return createElement(ConfirmationDialog, (Title = t("inspection_result.delete_title"), {
            Description: t("inspection_result.delete_confirmation"),
            IsOpen: true,
            OnClose: () => {
                setIsDeleteConfirmOpen(false);
            },
            OnConfirm: () => {
                props.Dispatch(new Msg(47, [props.ToolId, new InspectionResultId_1(props.InspectionResult.Id)]));
                props.OnClose();
            },
            Title: Title,
        }));
    }
    else {
        return createElement(Dialog, (Title_1 = t("inspection_result.edit"), {
            Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => {
                let elems;
                return append(singleton(reactElement("div", createObj(singleton_1((elems = [reactElement("label", {
                    className: join(" ", ["text-sm", "font-bold"]),
                    children: t("inspection_result.template"),
                }), reactElement("p", {
                    className: join(" ", ["text-sm", "text-gray-600", "mt-1"]),
                    children: props.InspectionResult.InspectionTemplateName,
                })], ["children", reactApi.Children.toArray(Array.from(elems))]))))), delay(() => {
                    let matchValue_2, title, elems_1;
                    return append((matchValue_2 = props.InspectionResult.ReminderTitle, (matchValue_2 == null) ? (empty()) : ((title = matchValue_2, singleton(reactElement("div", createObj(singleton_1((elems_1 = [reactElement("label", {
                        className: join(" ", ["text-sm", "font-bold"]),
                        children: t("inspection_result.appointment"),
                    }), reactElement("p", {
                        className: join(" ", ["text-sm", "text-gray-600", "mt-1"]),
                        children: title,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])))))))), delay(() => append(singleton(createElement(DatePicker, {
                        ComponentState: "enabled",
                        IsClearable: false,
                        Label: t("inspection_result.date"),
                        OnChange: setInspectionDate,
                        TestId: "edit-inspection-result-date-picker",
                        Value: unwrap(inspectionDate),
                    })), delay(() => append((length(resultOptions) > 0) ? singleton(createElement(SelectWithColor, {
                        ComponentState: "enabled",
                        IsClearable: false,
                        Label: t("inspection_result.result"),
                        NoOptionsMessage: "general.no_options",
                        OnChange: setSelectedResultOption,
                        Options: resultOptions,
                        PlaceholderKey: "inspection_result.result_placeholder",
                        TestId: "edit-inspection-result-result-select",
                        Value: unwrap(selectedResultOption),
                    })) : empty(), delay(() => singleton(createElement(TextArea, {
                        ComponentState: "enabled",
                        Label: t("inspection_result.comment"),
                        OnChange: setComment,
                        TestId: "edit-inspection-result-comment",
                        Value: comment,
                    }))))))));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))),
            Controls: ofArray([createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("general.delete"),
                OnClick: () => {
                    setIsDeleteConfirmOpen(true);
                },
                TestId: "delete-inspection-result",
                Variant: "redButton",
            }), createElement(TextButton, {
                ComponentState: "enabled",
                Label: t("general.cancel"),
                OnClick: props.OnClose,
                TestId: "cancel-edit-inspection-result",
                Variant: "blueButton",
            }), createElement(TextButton, {
                ComponentState: ((selectedResultOption == null) ? true : (inspectionDate == null)) ? "disabled" : "enabled",
                Label: t("general.save"),
                OnClick: () => {
                    let matchResult, date, resultOpt;
                    if (inspectionDate != null) {
                        if (selectedResultOption != null) {
                            matchResult = 0;
                            date = inspectionDate;
                            resultOpt = selectedResultOption;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0: {
                            props.Dispatch(new Msg(45, [props.ToolId, new InspectionResultId_1(props.InspectionResult.Id), new DTO_UpdateInspectionResultDto(date, resultOpt.value, (resultOpt.color === "#22c55e") ? (new InspectionResultStatus(0, [])) : (new InspectionResultStatus(1, [])), comment, props.InspectionResult.DocumentIds)]));
                            props.OnClose();
                            break;
                        }
                        case 1: {
                            break;
                        }
                    }
                },
                TestId: "save-edit-inspection-result",
                Variant: "blueButton",
            })]),
            IsOpen: props.IsOpen,
            OnClose: props.OnClose,
            Title: Title_1,
        }));
    }
}

function InspectionStatusOverview(props) {
    let elems_7, elems_6;
    const t = useTranslation()[0];
    const now = date_3(utcNow());
    const relevantTemplates = filter((tmpl) => exists((catId) => contains(catId, props.ToolCategoryIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), tmpl.CategoryIds), props.InspectionTemplates);
    if (isEmpty(relevantTemplates)) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["px-6", "pt-6", "pb-2"])], (elems_7 = [reactElement("h3", {
            className: join(" ", ["text-sm", "font-semibold", "text-gray-700", "mb-3"]),
            children: t("inspection_status.title"),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-1", "md:grid-cols-2", "lg:grid-cols-3", "gap-3", "mb-4"])], (elems_6 = toList(delay(() => collect((tmpl_1) => {
            let r_6, nextDue_2, nextDue_3, elems_5, elems, elems_4, elems_1, elems_2, elems_3;
            const lastResult = tryHead(sortByDescending((r_1) => r_1.InspectionDate, filter((r) => (r.InspectionTemplateId === tmpl_1.Id), props.InspectionResults), {
                Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
            }));
            const nextDueDate = bind((r_4) => calcNextInspectionDate(tmpl_1.Interval, tmpl_1.CustomInterval, r_4.InspectionDate), tryHead(sortByDescending((r_3) => r_3.InspectionDate, filter((r_2) => {
                if (r_2.InspectionTemplateId === tmpl_1.Id) {
                    return equals(r_2.ResultStatus, new InspectionResultStatus(0, []));
                }
                else {
                    return false;
                }
            }, props.InspectionResults), {
                Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
            })));
            const status = (lastResult != null) ? (equals(lastResult.ResultStatus, new InspectionResultStatus(1, [])) ? ((r_6 = lastResult, new InspectionStatus(2, []))) : ((nextDueDate == null) ? (new InspectionStatus(3, [])) : ((compare(date_3(nextDueDate), now) < 0) ? ((nextDue_2 = nextDueDate, new InspectionStatus(2, []))) : ((compare(date_3(nextDueDate), addDays(now, 30)) <= 0) ? ((nextDue_3 = nextDueDate, new InspectionStatus(1, []))) : (new InspectionStatus(0, [])))))) : (new InspectionStatus(3, []));
            const statusColor = (status.tag === 1) ? "orange" : ((status.tag === 2) ? "red" : ((status.tag === 3) ? "orange" : "green"));
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("border"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("p-4"), delay(() => append(singleton("border-border"), delay(() => {
                const matchValue_1 = status;
                return (matchValue_1.tag === 1) ? singleton("bg-orange-50/50") : ((matchValue_1.tag === 2) ? singleton("bg-red-50/50") : ((matchValue_1.tag === 3) ? singleton("bg-gray-50/50") : singleton("bg-green-50/50")));
            })))))))))))], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "mb-2"])], (elems = [createElement(ColoredDot, {
                Color: statusColor,
            }), reactElement("span", {
                className: join(" ", ["text-sm", "font-medium", "text-gray-900"]),
                children: tmpl_1.Name,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["text-xs", "text-gray-500", "space-y-1"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between"])], (elems_1 = [reactElement("span", {
                children: t("inspection_status.interval"),
            }), reactElement("span", {
                className: join(" ", ["text-gray-700"]),
                children: formatReminderInterval(t, tmpl_1.Interval, tmpl_1.CustomInterval),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between"])], (elems_2 = [reactElement("span", {
                children: t("inspection_status.last_inspection"),
            }), reactElement("span", {
                className: join(" ", ["text-gray-700"]),
                children: (lastResult == null) ? t("inspection_status.never") : toString(toLocalTime(lastResult.InspectionDate), "dd.MM.yyyy"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between"])], (elems_3 = [reactElement("span", {
                children: t("inspection_status.next_due"),
            }), reactElement("span", {
                className: join(" ", toList(delay(() => ((status.tag === 2) ? singleton("text-red-600 font-medium") : ((status.tag === 1) ? singleton("text-orange-600 font-medium") : singleton("text-gray-700")))))),
                children: (nextDueDate == null) ? t("inspection_status.not_yet_determined") : toString(toLocalTime(nextDueDate), "dd.MM.yyyy"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
        }, relevantTemplates))), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
    }
}

function InspectionSection(props) {
    let elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsCreateDialogOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setEditingResult = patternInput_2[1];
    let canEdit;
    const matchValue = props.UserData.Role;
    switch (matchValue) {
        case "user": {
            canEdit = false;
            break;
        }
        default:
            canEdit = true;
    }
    return reactElement("div", createObj(singleton_1((elems_2 = toList(delay(() => append(singleton(createElement(CreateInspectionResultDialog, {
        InspectionTemplates: props.InspectionTemplates,
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsCreateDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(40, []));
            props.Dispatch(new Msg(26, []));
            props.Dispatch(new Msg(3, []));
        },
        ToolCategoryIds: props.ToolCategoryIds,
        ToolId: props.ToolId,
    })), delay(() => {
        let matchValue_1;
        return append((matchValue_1 = patternInput_2[0], (matchValue_1 == null) ? (empty()) : singleton(createElement(EditInspectionResultDialog, {
            Dispatch: props.Dispatch,
            InspectionResult: matchValue_1,
            InspectionTemplates: props.InspectionTemplates,
            IsOpen: true,
            OnClose: () => {
                setEditingResult(undefined);
            },
            ToolId: props.ToolId,
        }))), delay(() => append(singleton(createElement(InspectionStatusOverview, {
            InspectionResults: props.InspectionResults,
            InspectionTemplates: props.InspectionTemplates,
            ToolCategoryIds: props.ToolCategoryIds,
        })), delay(() => {
            let elems, TableRows, Options;
            return isEmpty(props.InspectionResults) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "justify-center", "py-8", "text-gray-500"])], (elems = toList(delay(() => append(singleton(reactElement("p", {
                className: join(" ", ["text-sm", "mb-4"]),
                children: t("inspection_result.empty_state"),
            })), delay(() => (canEdit ? singleton(createElement(Button, {
                ComponentState: "enabled",
                Label: t("inspection_result.create"),
                OnClick: () => {
                    setIsCreateDialogOpen(true);
                },
                TestId: "create-inspection-result",
                Variant: "primary",
            })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))) : singleton(createElement(Table, (TableRows = toArray(props.InspectionResults), (Options = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["inspection_date", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: canEdit ? "singleRow" : "disabled",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: [new ColumnDefinition$1("inspection_date", "", t("inspection_result.date"), (row) => (new CellContent(6, [row.InspectionDate])), "none", "date"), new ColumnDefinition$1("template_name", "", t("inspection_result.template"), (row_1) => (new CellContent(0, [row_1.InspectionTemplateName])), "text", "text"), new ColumnDefinition$1("result", "", t("inspection_result.result"), (row_2) => {
                    let elems_1;
                    const color = (row_2.ResultStatus.tag === 1) ? "#ef4444" : "#22c55e";
                    return new CellContent(1, [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2"])], (elems_1 = [reactElement("div", {
                        className: join(" ", ["w-3", "h-3", "rounded-full", "flex-shrink-0"]),
                        style: {
                            backgroundColor: color,
                        },
                    }), reactElement("span", {
                        children: row_2.Result,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))]);
                }, "text", "text"), new ColumnDefinition$1("comment", "", t("inspection_result.comment"), (row_3) => (new CellContent(0, [row_3.Comment])), "none", "text"), new ColumnDefinition$1("reminder", "", t("inspection_result.appointment"), (row_4) => {
                    const matchValue_3 = row_4.ReminderTitle;
                    return (matchValue_3 == null) ? (new CellContent(0, [""])) : (new CellContent(0, [matchValue_3]));
                }, "none", "text"), new ColumnDefinition$1("documents", "", t("inspection_result.documents"), (row_5) => (new CellContent(1, [createElement(Modal_OpenLinkedDocumentModalButtonModalSheet, {
                    Documents: filter((doc) => contains(DocumentId__get_unwrap(doc.Id), row_5.DocumentIds, {
                        Equals: (x, y) => (x === y),
                        GetHashCode: (x) => (stringHash(x) | 0),
                    }), props.Documents),
                    LinkedEntityId: new FileDialog_LinkedEntityId(1, [row_5.Id]),
                    OnClose: () => {
                        props.Dispatch(new Msg(26, []));
                        props.Dispatch(new Msg(40, []));
                    },
                    UploadType: new FileDialog_LinkedDocumentToolType(0, [new ToolId_4(parse(props.ToolId))]),
                    UserData: props.UserData,
                })])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (row_6) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                    EntityId: row_6.Id,
                })])), "none", "button")],
                Controls: toList(delay(() => (canEdit ? append(singleton(new TableControl$1(t("inspection_result.create"), Calendar_Add(), (_arg_5) => {
                    setIsCreateDialogOpen(true);
                }, false, false, "create-inspection-result")), delay(() => singleton(new TableControl$1(t("inspection_result.edit"), Pencil(), (rows) => {
                    let matchResult, row_7;
                    if (!isEmpty(rows)) {
                        if (isEmpty(tail_1(rows))) {
                            matchResult = 0;
                            row_7 = head_1(rows);
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0: {
                            setEditingResult(row_7);
                            break;
                        }
                        case 1: {
                            break;
                        }
                    }
                }, true, true, "edit-inspection-result")))) : empty()))),
                Options: Options,
                TableKey: "inspection-results",
                TableRows: TableRows,
            }))));
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

function ToolDetail(props) {
    let elems_14, elems_13, elems, Title, SubTitle, cats, matchValue, matchValue_1, matchValue_2, elems_1, elems_12;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState("overview-section-id");
    const setCurrentSelectedLink = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_2[1];
    const isVisibleForUser = isVisibleForUserByToolDetailDto(props.Tool, props.Storages, props.UserData);
    return reactElement("div", createObj(ofArray([["className", "flex grow flex-col"], (elems_14 = [createElement(OpenToolDeleteDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(5, []));
        },
        ToolId: new ToolId_4(parse(props.Tool.Id)),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,min(calc(100vw-16rem-2px-28px-11rem),80rem)]", "print:flex", "print:flex-col"])], (elems_13 = [reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2"])], (elems = [createElement(DetailViewHeader, (Title = ((props.Tool.MasterData.DisplayName !== "") ? props.Tool.MasterData.DisplayName : concat(props.Tool.MasterData.Manufacturer, " ", ...props.Tool.MasterData.Model)), (SubTitle = ((props.Tool.MasterData.DisplayName !== "") ? concat(props.Tool.MasterData.Manufacturer, " ", ...props.Tool.MasterData.Model) : undefined), {
        Badges: (cats = props.Tool.Categories, map((leaf) => createElement(Badge, {
            Color: leaf.ColorHex,
            Label: join(" > ", ofArray(split(leaf.CategoryName, [" > "], undefined, 0))),
            TestId: concat("category-badge-", ...leaf.CategoryId),
        }), filter((c) => !exists((o) => {
            if (o.CategoryName !== c.CategoryName) {
                return o.CategoryName.startsWith(c.CategoryName + " > ");
            }
            else {
                return false;
            }
        }, cats), cats))),
        OnBack: () => {
            RouterModule_nav(singleton_1("tools" + RouterModule_encodeQueryString(withoutProblemReportIdQueryParam())), 1, 1);
        },
        OnDelete: unwrap((props.Tool.AssignedSet == null) ? ((matchValue = props.UserData.Role, (matchValue === "system") ? (() => {
            setIsDeleteDialogOpen(true);
        }) : ((matchValue === "toolManager") ? (props.CustomerConfiguration.InventoryConfiguration.ToolManagerCanDeleteInventory ? (() => {
            setIsDeleteDialogOpen(true);
        }) : undefined) : ((matchValue === "user") ? undefined : (() => {
            setIsDeleteDialogOpen(true);
        }))))) : undefined),
        OnDuplicate: unwrap((matchValue_1 = props.UserData.Role, (matchValue_1 === "system") ? (() => {
            RouterModule_nav(ofArray(["tools", props.Tool.Id, "copy" + RouterModule_encodeQueryString(withoutProblemReportIdQueryParam())]), 1, 1);
        }) : ((matchValue_1 === "toolManager") ? (() => {
            RouterModule_nav(ofArray(["tools", props.Tool.Id, "copy" + RouterModule_encodeQueryString(withoutProblemReportIdQueryParam())]), 1, 1);
        }) : ((matchValue_1 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["tools", props.Tool.Id, "copy" + RouterModule_encodeQueryString(withoutProblemReportIdQueryParam())]), 1, 1);
        }))))),
        OnEdit: unwrap((matchValue_2 = props.UserData.Role, (matchValue_2 === "system") ? (() => {
            RouterModule_nav(ofArray(["tools", props.Tool.Id, "edit" + RouterModule_encodeQueryString(withoutProblemReportIdQueryParam())]), 1, 1);
        }) : ((matchValue_2 === "toolManager") ? (() => {
            RouterModule_nav(ofArray(["tools", props.Tool.Id, "edit" + RouterModule_encodeQueryString(withoutProblemReportIdQueryParam())]), 1, 1);
        }) : ((matchValue_2 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["tools", props.Tool.Id, "edit" + RouterModule_encodeQueryString(withoutProblemReportIdQueryParam())]), 1, 1);
        }))))),
        SubTitle: unwrap(SubTitle),
        Title: Title,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems_1 = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton({
            Id: "overview-section-id",
            Label: t("general.overview"),
        }), delay(() => append(singleton({
            Id: "master-data-section-id",
            Label: t("general.master_data"),
        }), delay(() => append(props.AccountSettings.InspectionsEnabled ? singleton({
            Id: "inspections-section-id",
            Label: t("inspection_result.title"),
        }) : empty(), delay(() => append(singleton({
            Id: "documents-section-id",
            Label: t("general.documents"),
        }), delay(() => append(singleton({
            Id: "appointments-section-id",
            Label: t("general.appointments"),
        }), delay(() => append(singleton({
            Id: "reservations-section-id",
            Label: t("navbar.reservation"),
        }), delay(() => append(singleton({
            Id: "notices-section-id",
            Label: t("notice.notices"),
        }), delay(() => {
            let matchValue_3;
            return append((matchValue_3 = props.UserData.Role, (matchValue_3 === "system") ? singleton({
                Id: "problem-report-section-id",
                Label: t("tool.reported_problems"),
            }) : ((matchValue_3 === "toolManager") ? singleton({
                Id: "problem-report-section-id",
                Label: t("tool.reported_problems"),
            }) : ((matchValue_3 === "user") ? (empty()) : singleton({
                Id: "problem-report-section-id",
                Label: t("tool.reported_problems"),
            })))), delay(() => append(singleton({
                Id: "barcodes-section-id",
                Label: isFeatureEnabled(new Feature(18, [])) ? t("general.qr_codes_and_nfc_tags") : t("general.qr_code"),
            }), delay(() => {
                const matchValue_4 = props.UserData.Role;
                switch (matchValue_4) {
                    case "user": {
                        return empty();
                    }
                    default:
                        return singleton({
                            Id: "history-section-id",
                            Label: t("general.history"),
                        });
                }
            }))));
        })))))))))))))))),
        OnSelectAnchor: setCurrentSelectedLink,
        SelectedAnchor: patternInput_1[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(singleton_1((elems_12 = toList(delay(() => {
        let elems_2;
        return append(singleton(reactElement("section", createObj(ofArray([["id", "overview-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_2 = [createElement(ToolDetailsArea, {
            AccountSettings: props.AccountSettings,
            CurrentUser: props.CurrentUser,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            HasManualHooks: props.HasManualHooks,
            InspectionResults: props.InspectionResults,
            InspectionTemplates: props.InspectionTemplates,
            IsVisibleForUser: isVisibleForUser,
            Notifications: props.Notifications,
            ProblemReports: props.ProblemReports,
            QuickOverviewDialog: props.QuickOverviewDialog,
            SetCurrentSelectedLink: setCurrentSelectedLink,
            Storages: props.Storages,
            Tool: props.Tool,
            ToolImages: props.ToolImages,
            UserConfiguration: props.UserConfiguration,
            UserData: props.UserData,
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_3, Title_1;
            return append(singleton(reactElement("section", createObj(ofArray([["id", "master-data-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_3 = [createElement(SectionContainer, (Title_1 = t("general.master_data"), {
                Content: createElement(MasterDataSection, {
                    AccountSettings: props.AccountSettings,
                    Currency: props.CustomerConfiguration.Currency,
                    Customer: props.UserData.Customer,
                    Tool: props.Tool,
                }),
                Title: unwrap(Title_1),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_4, Title_2;
                return append(props.AccountSettings.InspectionsEnabled ? singleton(reactElement("section", createObj(ofArray([["id", "inspections-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_4 = [createElement(TableContainer, (Title_2 = t("inspection_result.title"), {
                    Content: createElement(InspectionSection, {
                        Dispatch: props.Dispatch,
                        Documents: props.Documents,
                        InspectionResults: props.InspectionResults,
                        InspectionTemplates: props.InspectionTemplates,
                        ToolCategoryIds: map((_arg_7) => _arg_7.CategoryId, props.Tool.Categories),
                        ToolId: props.Tool.Id,
                        UserData: props.UserData,
                    }),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty(), delay(() => {
                    let elems_5, Title_3;
                    return append(singleton(reactElement("section", createObj(ofArray([["id", "documents-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_5 = [createElement(TableContainer, (Title_3 = t("general.documents"), {
                        Content: createElement(DocumentSection, {
                            Dispatch: props.Dispatch,
                            Documents: props.Documents,
                            IsVisibleForUser: isVisibleForUser,
                            ToolId: new ToolId_4(parse(props.Tool.Id)),
                            UserData: props.UserData,
                        }),
                        Title: unwrap(Title_3),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                        let elems_6, Title_4;
                        return append(singleton(reactElement("section", createObj(ofArray([["id", "appointments-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_6 = [createElement(TableContainer, (Title_4 = t("general.appointments"), {
                            Content: createElement(AppointmentSection, {
                                Dispatch: props.Dispatch,
                                Documents: props.Documents,
                                InspectionResults: props.InspectionResults,
                                InspectionTemplates: props.InspectionTemplates,
                                Tool: props.Tool,
                                UserData: props.UserData,
                            }),
                            Title: unwrap(Title_4),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                            let elems_7, Title_5;
                            return append(singleton(reactElement("section", createObj(ofArray([["id", "reservations-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_7 = [createElement(TableContainer, (Title_5 = t("navbar.reservation"), {
                                Content: createElement(ReservationSection, {
                                    Dispatch: props.Dispatch,
                                    Tool: props.Tool,
                                    UserData: props.UserData,
                                }),
                                Title: unwrap(Title_5),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                                let elems_8, Title_6;
                                return append(singleton(reactElement("section", createObj(ofArray([["id", "notices-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_8 = [createElement(SectionContainer, (Title_6 = t("notice.notices"), {
                                    Content: createElement(NoticeSection, {
                                        CustomerConfiguration: props.CustomerConfiguration,
                                        Dispatch: props.Dispatch,
                                        Tool: props.Tool,
                                        UserData: props.UserData,
                                        UserId: props.UserData.UserId,
                                    }),
                                    Title: unwrap(Title_6),
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                                    let matchValue_5, elems_9, Title_7;
                                    return append((matchValue_5 = props.UserData.Role, (matchValue_5 === "system") ? singleton(reactElement("section", createObj(ofArray([["id", "problem-report-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_9 = [createElement(TableContainer, (Title_7 = t("tool.reported_problems"), {
                                        Content: createElement(ProblemReportSection, {
                                            Dispatch: props.Dispatch,
                                            IsVisibleForUser: isVisibleForUser,
                                            ProblemReports: props.ProblemReports,
                                            SelectedProblemReport: unwrap(props.SelectedProblemReport),
                                            Tool: props.Tool,
                                            UserData: props.UserData,
                                            UserId: props.UserData.UserId,
                                        }),
                                        Title: unwrap(Title_7),
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : ((matchValue_5 === "toolManager") ? singleton(reactElement("section", createObj(ofArray([["id", "problem-report-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_9 = [createElement(TableContainer, (Title_7 = t("tool.reported_problems"), {
                                        Content: createElement(ProblemReportSection, {
                                            Dispatch: props.Dispatch,
                                            IsVisibleForUser: isVisibleForUser,
                                            ProblemReports: props.ProblemReports,
                                            SelectedProblemReport: unwrap(props.SelectedProblemReport),
                                            Tool: props.Tool,
                                            UserData: props.UserData,
                                            UserId: props.UserData.UserId,
                                        }),
                                        Title: unwrap(Title_7),
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : ((matchValue_5 === "user") ? (empty()) : singleton(reactElement("section", createObj(ofArray([["id", "problem-report-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_9 = [createElement(TableContainer, (Title_7 = t("tool.reported_problems"), {
                                        Content: createElement(ProblemReportSection, {
                                            Dispatch: props.Dispatch,
                                            IsVisibleForUser: isVisibleForUser,
                                            ProblemReports: props.ProblemReports,
                                            SelectedProblemReport: unwrap(props.SelectedProblemReport),
                                            Tool: props.Tool,
                                            UserData: props.UserData,
                                            UserId: props.UserData.UserId,
                                        }),
                                        Title: unwrap(Title_7),
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))))))), delay(() => {
                                        let elems_10, Title_8;
                                        return append(singleton(reactElement("section", createObj(ofArray([["id", "barcodes-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_10 = [createElement(TableContainer, (Title_8 = (isFeatureEnabled(new Feature(18, [])) ? t("general.qr_codes_and_nfc_tags") : t("general.qr_code")), {
                                            Content: isFeatureEnabled(new Feature(18, [])) ? createElement(AssetIdentifiersSection, {
                                                AssetIdentifiers: props.Tool.AssetIdentifiers,
                                                Dispatch: props.Dispatch,
                                                UserData: props.UserData,
                                            }) : createElement(BarcodeSection, {
                                                Dispatch: props.Dispatch,
                                                QRCodeIds: map((_arg_8) => _arg_8.Value, filter((assetIdentifier) => (assetIdentifier.Kind === "qrCode"), props.Tool.AssetIdentifiers)),
                                                UserData: props.UserData,
                                            }),
                                            Title: unwrap(Title_8),
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => {
                                            let elems_11, Title_9, Title_10, ToolName, Title_11, matchValue_7;
                                            const matchValue_6 = props.UserData.Role;
                                            switch (matchValue_6) {
                                                case "user": {
                                                    return empty();
                                                }
                                                default:
                                                    return singleton(reactElement("section", createObj(ofArray([["id", "history-section-id"], ["className", join(" ", toList(delay(() => ((props.SelectedProblemReport != null) ? singleton("print:hidden") : empty()))))], (elems_11 = [createElement(TableContainerWithTabs, (Title_9 = t("history.title"), {
                                                        Tab1: (Title_10 = t("history.events"), {
                                                            Content: createElement(HistorySection, (ToolName = ToolDetailDto__ReadableDisplayName(props.Tool), {
                                                                BusinessUnitImageUrl: unwrap(props.BusinessUnitImageUrl),
                                                                CustomerConfiguration: props.CustomerConfiguration,
                                                                Dispatch: props.Dispatch,
                                                                Documents: props.Documents,
                                                                HistoryRows: props.History,
                                                                InventoryNumber: props.Tool.MasterData.InventoryNumber,
                                                                QrCodeIds: map((_arg_9) => _arg_9.Value, filter((assetIdentifier_1) => (assetIdentifier_1.Kind === "qrCode"), props.Tool.AssetIdentifiers)),
                                                                ToolId: props.Tool.Id,
                                                                ToolName: ToolName,
                                                                UserData: props.UserData,
                                                            })),
                                                            Title: Title_10,
                                                        }),
                                                        Tab2: (Title_11 = t("history.changes"), {
                                                            Content: (matchValue_7 = props.Changelogs, (matchValue_7.tag === 0) ? createElement(Skeleton, {
                                                                Variant: "table",
                                                            }) : createElement(ChangelogTable, {
                                                                Changelogs: matchValue_7.fields[0],
                                                            })),
                                                            OnSelect: () => {
                                                                props.Dispatch(new Msg(37, []));
                                                            },
                                                            Title: Title_11,
                                                        }),
                                                        Title: unwrap(Title_9),
                                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
                                            }
                                        }));
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_12))]))))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])));
}

export function ViewToolView(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setAssignToolsTourTooltipDismissed = patternInput_1[1];
    const patternInput_2 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initViewTool(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.ToolId, props.UserData], undefined);
    const state_1 = patternInput_2[0];
    const clearAssignTourFromUrl = () => {
        RouterModule_nav(ofArray(["tools", unwrapToolId(props.ToolId) + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())]), 1, 1);
    };
    const matchValue = state_1.Tool;
    const matchValue_1 = state_1.ProblemReports;
    const matchValue_2 = state_1.UserConfiguration;
    const matchValue_3 = state_1.Documents;
    const matchValue_4 = state_1.CustomerConfiguration;
    const matchValue_5 = state_1.Storages;
    const matchValue_6 = state_1.History;
    const matchValue_7 = state_1.Notifications;
    const matchValue_8 = state_1.AccountSettings;
    const matchValue_9 = state_1.BusinessUnitImageUrl;
    let matchResult, accountSettings, businessUnitImageUrl, customerConfiguration, documents, history, notifications, problemReports, storages, tool, userConfiguration;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_9.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_8.fields[0];
        businessUnitImageUrl = matchValue_9.fields[0];
        customerConfiguration = matchValue_4.fields[0];
        documents = matchValue_3.fields[0];
        history = matchValue_6.fields[0];
        notifications = matchValue_7.fields[0];
        problemReports = matchValue_1.fields[0];
        storages = matchValue_5.fields[0];
        tool = matchValue.fields[0];
        userConfiguration = matchValue_2.fields[0];
    }
    switch (matchResult) {
        case 0: {
            const xs_1 = toList(delay(() => {
                let InspectionResults, matchValue_11, InspectionTemplates, matchValue_12, matchValue_13;
                return append(singleton(createElement(ToolDetail, (InspectionResults = ((matchValue_11 = state_1.InspectionResults, (matchValue_11.tag === 0) ? empty_1() : matchValue_11.fields[0])), (InspectionTemplates = ((matchValue_12 = state_1.InspectionTemplates, (matchValue_12.tag === 0) ? empty_1() : matchValue_12.fields[0])), {
                    AccountSettings: accountSettings,
                    BusinessUnitImageUrl: unwrap(businessUnitImageUrl),
                    Changelogs: state_1.Changelogs,
                    CurrentUser: props.CurrentUser,
                    CustomerConfiguration: customerConfiguration,
                    Dispatch: patternInput_2[1],
                    Documents: documents,
                    FormState: state_1.FormState,
                    HasManualHooks: (matchValue_13 = state_1.ManualHooks, (matchValue_13.tag === 0) ? false : !isEmpty(matchValue_13.fields[0])),
                    History: history,
                    InspectionResults: InspectionResults,
                    InspectionTemplates: InspectionTemplates,
                    Notifications: notifications,
                    ProblemReports: problemReports,
                    QuickOverviewDialog: state_1.QuickOverviewDialog,
                    SelectedProblemReport: unwrap(state_1.SelectedProblemReport),
                    Storages: storages,
                    Tool: tool,
                    ToolImages: state_1.ToolImages,
                    UserConfiguration: userConfiguration,
                    UserData: props.UserData,
                })))), delay(() => {
                    let Steps;
                    return (((tool.AssignedSet == null) && isAssignToolsOnboardingTourToolDetailPhase()) && !patternInput_1[0]) ? singleton(createElement(TourGuide, (Steps = singleton_1(new TourStep("[data-test-id=\'onboarding-tour-tool-assign-button-anchor\']", t("onboarding.tour.assign_tools_detail_title"), reactElement("div", {
                        children: t("onboarding.tour.assign_tools_detail_content"),
                    }), "bottom", false)), {
                        IsRunning: true,
                        Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                        OnFinish: () => {
                            setAssignToolsTourTooltipDismissed(true);
                            clearAssignTourFromUrl();
                        },
                        OnSkip: () => {
                            setAssignToolsTourTooltipDismissed(true);
                            clearAssignTourFromUrl();
                        },
                        ScrollFirstStep: false,
                        Steps: Steps,
                    }))) : empty();
                }));
            }));
            return react.createElement(react.Fragment, {}, ...xs_1);
        }
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

